<template>
  <v-container class="px-2 forma-erp">
    <v-row no-gutters justify="center" class="pa-0">
      <v-col cols="12" sm="12" md="12" xs="12" lg="12" xl="12">

          <v-form
            name="DocumentForm"
            autocomplete="off">
            <v-row no-gutters>
               
              <v-col cols="12" sm="3" md="3" xs="3" lg="3" xl="3" class="py-0 px-2">
                   <h2>
                  <span v-if="this.$store.state.editItem  === 0">
                    {{ documentNameLoc }}
                  </span>
                  <span v-if="this.$store.state.editItem === 1">
                    {{ documentNameLoc }} {{mainledger.BookID ? locBookID : 0}}
                  </span>                  
                </h2>
              </v-col>
              <v-col cols="12" sm="8" md="8" xs="8" lg="8" xl="8" class="py-0 px-2">
                  <span style="font-weight:bold">{{mainledger.CompanyNameDatabase}}, {{ parseInt(mainledger.BusinessYear) || '' }}, {{mainledger.First}} {{mainledger.Last}}, {{mainledger.email}} </span>
              </v-col>
            </v-row>
            <br>

            <!-- DOKUMENT -->
            <v-card outlined class="mb-4">
              <v-card-title class="naslov-kartice">
                Dokument
                <v-spacer></v-spacer>
                  <div class="d-flex align-center flex-wrap" style="gap:8px">
                    <v-btn v-if="showERacun && !haveeRacun" small color="primary" @click="loadeInvoice()">Učitaj eRačun</v-btn>
                    <div v-if="showUploadERacun && !haveeRacun" style="min-width:380px; max-width:520px">
                      <v-file-input outlined dense hide-details v-model="somefile" single label="File input"></v-file-input>
                    </div>
                    <v-btn v-if="showUploadERacun && !haveeRacun" small class="primary" @click="onUpload">Učitaj</v-btn>
                    <span v-if="haveeRacun" class="caption grey--text text--darken-2">{{ mainledger.filexml_originalname }}</span>
                    <v-btn v-if="haveeRacun" small text color="primary" @click="onDownload">download</v-btn>

                    <v-divider vertical class="mx-2" v-if="(showERacun || showUploadERacun || haveeRacun) && (showPDF || showUploadPDF || havePDF)"></v-divider>

                    <v-btn v-if="showPDF && !havePDF" small color="primary" @click="loadPDF()">Učitaj pdf</v-btn>
                    <div v-if="showUploadPDF && !havePDF" style="min-width:380px; max-width:520px">
                      <v-file-input outlined dense hide-details v-model="somefile" single label="File input"></v-file-input>
                    </div>
                    <v-btn v-if="showUploadPDF && !havePDF" small class="primary" @click="onUploadPDF">Učitaj</v-btn>
                    <span v-if="havePDF" class="caption grey--text text--darken-2">{{ mainledger.MLFree2}}</span>
                    <v-btn v-if="havePDF" small text color="primary" @click="onDownloadPDF">Download</v-btn>
                    <v-btn v-if="havePDF" small text color="primary" @click="openPDF">Otvori</v-btn>
                  </div>
              </v-card-title>
              <v-card-text class="pt-4 pb-1">

                <v-row dense>
                  <v-col cols="12" sm="6" md="4" lg="2" class="pr-3">
                    <span v-if="haveNew === true">
                      <v-text-field outlined hide-details="auto" dense label="Vrsta knjige" v-model="mainledger.BookName" readonly></v-text-field>
                    </span>
                    <span v-if="haveNew === false">
                      <v-select
                        outlined hide-details="auto"
                        dense
                        label="Vrsta knjige"
                        :items="bookType"
                        v-model="bookTypeSelected"
                        value="bookType.value"
                        single-line
                        return-object
                        persistent-hint
                        clearable
                      ></v-select>
                    </span>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" lg="2" class="pr-3">
                    <v-text-field
                      v-if="$store.state.documentSide !== 2"
                      outlined hide-details="auto"
                      dense
                      label="Podvrsta"
                      value="—"
                      background-color="grey lighten-4"
                      readonly
                    ></v-text-field>
                    <v-select
                      v-if="$store.state.documentSide === 2"
                      outlined hide-details="auto"
                      dense
                      label="Podvrsta"
                      :items="bookSubType"
                      item-text="descHR"
                      v-model="bookSubTypeSelected"
                      value="bookSubType.value"
                      single-line
                      return-object
                      persistent-hint
                      clearable
                    ></v-select>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" lg="2" class="pr-3">
                    <v-text-field
                      v-if="!admin"
                      outlined hide-details="auto"
                      dense
                      label="Broj knjiženja"
                      :value="parseInt(mainledger.BookID) || 0"
                      background-color="grey lighten-4"
                      readonly
                    ></v-text-field>
                    <v-text-field
                      v-if="admin"
                      outlined hide-details="auto"
                      dense
                      label="Broj knjiženja"
                      v-model.number="mainledger.BookID"
                      type="number"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" lg="2" class="pr-3">
                    <v-text-field
                      ref="bookingd"
                      outlined hide-details="auto"
                      dense
                      :label="lang.BookingDate"
                      v-model="mainledger.BookingDate"
                      type="date"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" lg="2" class="pr-3">
                    <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="lang.InvoiceDate"
                      v-model="mainledger.InvoiceDate"
                      type="date"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" lg="2" class="pr-3">
                    <v-text-field
                      ref="innr"
                      outlined hide-details="auto"
                      dense
                      label="Broj računa"
                      v-model="mainledger.InvoiceNumber"
                    ></v-text-field>
                  </v-col>
                </v-row>

              </v-card-text>
            </v-card>

            <!-- PARTNER -->
            <v-card outlined class="mb-4">
              <v-card-title class="naslov-kartice">
                Partner
              </v-card-title>
              <v-card-text class="pt-4 pb-1">

                <!-- odabir partnera: kad ga jos nema ili kad ga korisnik mijenja -->
                <v-row dense align="center" v-if="prikaziIzbornikPartnera">
                  <v-col cols="12" sm="6" md="4" lg="4" class="pr-3">
                    <v-autocomplete outlined hide-details="auto"
                      ref="selpartner"
                      dense
                      :items="partners"
                      v-model="selectPa"
                      :label="langC.SelectPartner"
                      item-text="partnerName"
                      item-value="id"
                      return-object
                      persistent-hint
                      clearable
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="3" lg="2" class="pr-3">
                    <v-text-field outlined hide-details="auto" dense label="OIB *" v-model="mainledger.partnerVATID" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="5" lg="6" class="text-right">
                    <!-- true = korisnik je sam trazio. Uvoz eRacuna zove istu
                         metodu bez toga i tada se podaci s racuna ne diraju. -->
                    <v-btn text small color="primary" @click="findByVATID(true)">{{langC.checkVATID}}</v-btn>
                    <v-btn text small color="primary" @click="addeditPartner()">{{lang.PartnerSave}}</v-btn>
                  </v-col>
                </v-row>

                <!-- odabrani partner: podaci lijevo, radnje desno -->
                <v-row dense v-if="!prikaziIzbornikPartnera">
                  <v-col cols="12" sm="7" md="8" lg="8">
                    <div class="subtitle-1 font-weight-medium">{{ mainledger.partnerName }}</div>
                    <div class="caption grey--text text--darken-2">{{ partnerAdresaTxt }}</div>
                    <div class="caption grey--text text--darken-2">{{ partnerKontaktTxt }}</div>
                  </v-col>
                  <v-col cols="12" sm="5" md="4" lg="4" class="text-right">
                    <v-btn text small color="primary" @click="mijenjamPartnera = true">Promijeni partnera</v-btn>
                    <v-btn text small color="primary" @click="urediPartnera = !urediPartnera">
                      {{ urediPartnera ? 'Sakrij podatke' : 'Uredi podatke' }}
                    </v-btn>
                  </v-col>
                </v-row>

                <div v-if="!prikaziIzbornikPartnera && !prikaziPoljaPartnera" class="caption grey--text pb-2">
                  Adresa, IBAN i e-pošta popunjavaju se iz šifrarnika — polja se otvaraju na „Uredi podatke“.
                </div>

                <div v-if="prikaziPoljaPartnera">
                  <v-row dense>
                    <v-col cols="12" sm="6" md="4" lg="4" class="pr-3">
                      <v-text-field outlined hide-details="auto" dense label="Naziv partnera" v-model="mainledger.partnerName"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                      <v-text-field outlined hide-details="auto" dense label="IBAN" v-model="mainledger.partnerBankIBAN"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                      <v-text-field outlined hide-details="auto" dense :label="lang.Partneremail" v-model="mainledger.partneremail" required></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                      <v-text-field outlined hide-details="auto" dense label="Ulica" v-model="mainledger.partnerStreet"></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="3" md="2" lg="1" class="pr-3">
                      <v-text-field outlined hide-details="auto" dense label="Br" v-model="mainledger.partnerBuildingNameNumber"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                      <v-text-field outlined hide-details="auto" dense label="Mjesto" v-model="mainledger.partnerCity"></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="3" md="2" lg="1" class="pr-3">
                      <v-text-field outlined hide-details="auto" dense label="Pošta" v-model="mainledger.partnerPostcode"></v-text-field>
                    </v-col>
                  </v-row>
                </div>

              </v-card-text>
            </v-card>

            <!-- IZNOS I PDV -->
            <v-card outlined class="mb-4">
              <v-card-title class="naslov-kartice">
                Iznos i PDV
              </v-card-title>
              <v-card-text class="pt-4 pb-1">

                <v-row dense align="center">
                  <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                    <v-text-field dense outlined hide-details="auto"
                        class="title"
                        label="Iznos računa"
                        v-model.number="mainledger.InvoiceAmount"
                        type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" sm="3" md="2" lg="2" class="pr-3">
                    <v-select outlined hide-details="auto" dense label="Valuta" :items="currnecyType" v-model="mainledger.HomeCurrency"></v-select>
                  </v-col>
                  <v-col cols="6" sm="3" md="2" lg="1" class="pr-3" v-if="BusinessYear <=2022">
                    <v-text-field outlined hide-details="auto" dense label="Tečaj" v-model.number="mainledger.ExRate" type="number"></v-text-field>
                  </v-col>
                  <v-col cols="6" sm="3" md="2" lg="1" class="pr-3" v-if="BusinessYear <=2022">
                    <v-select outlined hide-details="auto" dense label="Sekundarna valuta" :items="currnecyType" v-model="mainledger.ForeignCurrency"></v-select>
                  </v-col>
                  <v-col cols="6" sm="3" md="2" lg="2" class="pr-3" v-if="BusinessYear <=2022">
                    <v-text-field outlined hide-details="auto" dense label="Sekun.iznos" v-model.number="mainledger.InvoiceForeginAmount" type="number"></v-text-field>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="6" sm="3" md="2" lg="2" class="pr-3" v-if="showVAT">
                    <v-text-field outlined hide-details="auto" dense label="Porezna osnovica" v-model.number="mainledger.AmountNetto" type="number" disabled></v-text-field>
                  </v-col>
                  <v-col cols="6" sm="3" md="2" lg="2" v-if="showVAT">
                    <v-text-field outlined hide-details="auto" dense label="PDV ukupno" v-model.number="mainledger.AmountVAT" type="number" disabled></v-text-field>
                  </v-col>
                </v-row>

                <div v-if="showVAT">
                  <v-divider class="mt-3 mb-2"></v-divider>

                  <v-row dense class="grey--text text--darken-1">
                    <v-col cols="12" sm="2" md="2" lg="2" class="pr-2"><small>Stopa</small></v-col>
                    <v-col cols="6" sm="2" md="2" lg="2" class="pr-2"><small>Osnovica</small></v-col>
                    <v-col cols="6" sm="2" md="2" lg="2" class="pr-2"><small>PDV iznos</small></v-col>
                    <v-col cols="4" sm="2" md="2" lg="2" class="pr-2"><small>% odbitka</small></v-col>
                    <v-col cols="4" sm="2" md="2" lg="2" class="pr-2"><small>Odbitni PDV</small></v-col>
                    <v-col cols="4" sm="2" md="2" lg="2"><small>Neodbitni PDV</small></v-col>
                  </v-row>

                  <v-row dense align="center">
                    <v-col cols="12" sm="2" md="2" lg="2" class="pr-2">PDV 25%</v-col>
                    <v-col cols="6" sm="2" md="2" lg="2" class="pr-2">
                      <v-text-field outlined dense hide-details v-model.number="mainledger.VAT1Base" type="number"></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="2" md="2" lg="2" class="pr-2">
                      <v-text-field outlined dense hide-details v-model.number="mainledger.VAT1Amount" type="number"></v-text-field>
                    </v-col>
                    <v-col cols="4" sm="2" md="2" lg="2" class="pr-2">
                      <v-text-field outlined dense hide-details v-model.number="mainledger.VAT1PerCanUse" type="number"></v-text-field>
                    </v-col>
                    <v-col cols="4" sm="2" md="2" lg="2" class="pr-2">
                      <v-text-field outlined dense hide-details v-model.number="mainledger.VAT1CanUse" type="number"></v-text-field>
                    </v-col>
                    <v-col cols="4" sm="2" md="2" lg="2">
                      <v-text-field outlined dense hide-details v-model.number="mainledger.VAT1CanTUse" type="number" disabled></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row dense align="center" v-if="prikaziPdv13" class="mt-1">
                    <v-col cols="12" sm="2" md="2" lg="2" class="pr-2">PDV 13%</v-col>
                    <v-col cols="6" sm="2" md="2" lg="2" class="pr-2">
                      <v-text-field outlined dense hide-details v-model.number="mainledger.VAT2Base" type="number"></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="2" md="2" lg="2" class="pr-2">
                      <v-text-field outlined dense hide-details v-model.number="mainledger.VAT2Amount" type="number"></v-text-field>
                    </v-col>
                    <v-col cols="4" sm="2" md="2" lg="2" class="pr-2">
                      <v-text-field outlined dense hide-details v-model.number="mainledger.VAT2PerCanUse" type="number"></v-text-field>
                    </v-col>
                    <v-col cols="4" sm="2" md="2" lg="2" class="pr-2">
                      <v-text-field outlined dense hide-details v-model.number="mainledger.VAT2CanUse" type="number"></v-text-field>
                    </v-col>
                    <v-col cols="4" sm="2" md="2" lg="2">
                      <v-text-field outlined dense hide-details v-model.number="mainledger.VAT2CanTUse" type="number" disabled></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row dense align="center" v-if="prikaziPdv5" class="mt-1">
                    <v-col cols="12" sm="2" md="2" lg="2" class="pr-2">PDV 5%</v-col>
                    <v-col cols="6" sm="2" md="2" lg="2" class="pr-2">
                      <v-text-field outlined dense hide-details v-model.number="mainledger.VAT3Base" type="number"></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="2" md="2" lg="2" class="pr-2">
                      <v-text-field outlined dense hide-details v-model.number="mainledger.VAT3Amount" type="number"></v-text-field>
                    </v-col>
                    <v-col cols="4" sm="2" md="2" lg="2" class="pr-2">
                      <v-text-field outlined dense hide-details v-model.number="mainledger.VAT3PerCanUse" type="number"></v-text-field>
                    </v-col>
                    <v-col cols="4" sm="2" md="2" lg="2" class="pr-2">
                      <v-text-field outlined dense hide-details v-model.number="mainledger.VAT3CanUse" type="number"></v-text-field>
                    </v-col>
                    <v-col cols="4" sm="2" md="2" lg="2">
                      <v-text-field outlined dense hide-details v-model.number="mainledger.VAT3CanTUse" type="number" disabled></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row dense align="center" v-if="prikaziOstaloPdv" class="mt-1">
                    <v-col cols="12" sm="2" md="2" lg="2" class="pr-2">Ostalo</v-col>
                    <v-col cols="6" sm="2" md="2" lg="2" class="pr-2">
                      <v-text-field outlined dense hide-details label="Neoporezivi iznos" v-model.number="mainledger.VAT4Base" type="number"></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="2" md="2" lg="2" class="pr-2">
                      <v-text-field outlined dense hide-details label="PDV 0%" v-model.number="mainledger.VATZero" type="number"></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row dense class="mt-2" v-if="!prikaziPdv13 || !prikaziPdv5 || !prikaziOstaloPdv || viewShowOut">
                    <v-col cols="12">
                      <v-btn v-if="!prikaziPdv13" outlined small color="primary" class="mr-2" @click="rucnoPdv13 = true">+ Stopa 13%</v-btn>
                      <v-btn v-if="!prikaziPdv5" outlined small color="primary" class="mr-2" @click="rucnoPdv5 = true">+ Stopa 5%</v-btn>
                      <v-btn v-if="!prikaziOstaloPdv" outlined small color="primary" class="mr-2" @click="rucnoOstaloPdv = true">+ Neoporezivo / PDV 0%</v-btn>
                      <v-btn v-if="viewShowOut" outlined small color="primary" class="mr-2" @click="showOut1()">Dodatno <v-icon small v-if="!showOut">mdi-chevron-down</v-icon><v-icon small v-if="showOut">mdi-chevron-up</v-icon></v-btn>
                      <span class="caption grey--text text--darken-1">stopa se dodaje po potrebi; ako je na računu upisana, prikazuje se odmah</span>
                    </v-col>
                  </v-row>
                </div>

              </v-card-text>
            </v-card>
            <!-- PLAĆANJE -->
            <v-card outlined class="mb-4">
              <v-card-title class="naslov-kartice">
                Plaćanje
              </v-card-title>
              <v-card-text class="pt-4 pb-1">
                <v-row dense align="center">
                  <v-col cols="12" sm="6" md="3" lg="2" class="pr-3">
                    <v-select outlined hide-details="auto"
                      :items="naciniPlacanja"
                      item-text="naziv"
                      item-value="oznaka"
                      v-model="nacinPlacanjaOznaka"
                      label="Način plaćanja"
                      dense
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="3" lg="2" class="pr-3">
                    <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="lang.InvoicePaymentDeadlineDate"
                      v-model="mainledger.InvoicePaymentDeadlineDate"
                      type="date"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3" lg="2" class="pr-3">
                    <v-text-field outlined hide-details="auto" dense label="Broj" v-model="mainledger.InvoiceNumber"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3" lg="2" class="pr-3">
                    <v-text-field outlined hide-details="auto" dense label="Datum plaćanja" v-model="mainledger.paidDate" type="date"></v-text-field>
                  </v-col>
                  <!-- Kvacica ide desno, a ne izmedju polja: tako ne prekida
                       niz unosa i red ostaje jedan. -->
                  <v-col cols="12" md="auto" class="ml-md-auto">
                    <v-checkbox dense hide-details class="mt-0 pt-0" :label="lang.PaidClosed" v-model="mainledger.paidClosed"></v-checkbox>
                  </v-col>
                </v-row>
                <v-row dense v-if="mainledger.virmanId || mainledger.paymentApproved">
                  <v-col cols="12" class="pb-3">
                    <v-chip v-if="mainledger.virmanId" small color="blue lighten-5" class="mr-2">Virman napravljen</v-chip>
                    <v-chip v-if="mainledger.paymentApproved" small color="blue lighten-5">
                      Plaćanje odobrio {{ mainledger.paymentApprovedBy }}
                    </v-chip>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <!-- PDV: OSLOBOĐENJA I POSEBNI POSTUPCI -->
            <v-card outlined class="mb-4">
              <v-card-title class="naslov-kartice">
                PDV — oslobođenja i posebni postupci
              </v-card-title>
              <v-card-text class="pt-2 pb-1">

                <v-btn text small color="primary" class="pl-0" @click="otvorenoOslobodjenja = !otvorenoOslobodjenja" v-if="!prikaziOslobodjenja || !otvorenoOslobodjenja">
                  <v-icon small>{{ prikaziOslobodjenja ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                  Prijenos porezne obveze i isporuke u EU
                </v-btn>

                <v-row dense v-if="prikaziOslobodjenja" class="mt-2">
                  <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                    <v-text-field outlined hide-details="auto" dense label="Tuzemni prijenos por.ob" v-model.number="mainledger.VAT4Per" type="number"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                    <v-text-field outlined hide-details="auto" dense label="Isp.dob.u drugim drž.čl." v-model.number="mainledger.VAT4Base" type="number"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                    <v-text-field outlined hide-details="auto" dense label="Isp.dob. unutar EU" v-model.number="mainledger.VAT4Amount" type="number"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                    <v-text-field outlined hide-details="auto" dense label="Obavljene usluge unutar EU" v-model.number="mainledger.VAT4PerCanUse" type="number"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                    <v-text-field outlined hide-details="auto" dense label="Obav.isp.os bez sjedišta u RH" v-model.number="mainledger.VAT4CanUse" type="number"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                    <v-text-field outlined hide-details="auto" dense label="Sast.i post.dobara u drugoj drž.čl." v-model.number="mainledger.VAT4CanTUse" type="number"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                    <v-text-field outlined hide-details="auto" dense label="Isp. NPS u EU" v-model.number="mainledger.VAT5Per" type="number"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                    <v-text-field outlined hide-details="auto" dense label="U tuzem." v-model.number="mainledger.VAT5Base" type="number"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                    <v-text-field outlined hide-details="auto" dense label="izv. isporuke" v-model.number="mainledger.VAT5Amount" type="number"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                    <v-text-field outlined hide-details="auto" dense label="Ostala oslob." v-model.number="mainledger.VAT5PerCanUse" type="number"></v-text-field>
                  </v-col>
                </v-row>

                <v-btn text small color="primary" class="pl-0" @click="otvorenoDobraUsluge = !otvorenoDobraUsluge" v-if="!prikaziDobraUsluge || !otvorenoDobraUsluge">
                  <v-icon small>{{ prikaziDobraUsluge ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                  Razrada po dobrima i uslugama
                </v-btn>

                <div v-if="prikaziDobraUsluge">
                  <v-divider class="my-3" v-if="prikaziOslobodjenja"></v-divider>
                  <v-row dense align="center">
                    <v-col cols="12" sm="2" md="2" lg="2" class="pr-2">Dobra</v-col>
                    <v-col cols="6" sm="2" md="2" lg="2" class="pr-2">
                      <v-text-field outlined hide-details="auto" dense label="netto" v-model.number="mainledger.Goods" type="number"></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="2" md="2" lg="2" class="pr-2">
                      <v-text-field outlined hide-details="auto" dense label="PDV 25%" v-model.number="mainledger.Goods25" type="number"></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="2" md="2" lg="2" class="pr-2">
                      <v-text-field outlined hide-details="auto" dense label="PDV 13%" v-model.number="mainledger.Goods13" type="number"></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="2" md="2" lg="2" class="pr-2">
                      <v-text-field outlined hide-details="auto" dense label="PDV 5%" v-model.number="mainledger.Goods5" type="number"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row dense align="center">
                    <v-col cols="12" sm="2" md="2" lg="2" class="pr-2">Usluge</v-col>
                    <v-col cols="6" sm="2" md="2" lg="2" class="pr-2">
                      <v-text-field outlined hide-details="auto" dense label="netto" v-model.number="mainledger.Services" type="number"></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="2" md="2" lg="2" class="pr-2">
                      <v-text-field outlined hide-details="auto" dense label="PDV 25%" v-model.number="mainledger.Services25" type="number"></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="2" md="2" lg="2" class="pr-2">
                      <v-text-field outlined hide-details="auto" dense label="PDV 13%" v-model.number="mainledger.Services13" type="number"></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="2" md="2" lg="2" class="pr-2">
                      <v-text-field outlined hide-details="auto" dense label="PDV 5%" v-model.number="mainledger.Services5" type="number"></v-text-field>
                    </v-col>
                  </v-row>
                </div>

                <v-divider class="my-3" v-if="prikaziOslobodjenja || prikaziDobraUsluge"></v-divider>

                <v-btn text small color="primary" class="pl-0" @click="otvorenoUvoz = !otvorenoUvoz" v-if="!prikaziUvoz || !otvorenoUvoz">
                  <v-icon small>{{ prikaziUvoz ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                  Uvoz i PPO
                </v-btn>

                <v-row dense align="center" v-if="prikaziUvoz" class="mt-2">
                  <v-col cols="12" sm="4" md="3" lg="3">
                    <v-checkbox dense hide-details class="mt-0" :label="lang.importDOC" v-model="mainledger.MLBool1"></v-checkbox>
                  </v-col>
                  <v-col cols="12" sm="4" md="3" lg="3">
                    <v-checkbox dense hide-details class="mt-0" :label="lang.PayedVAT" v-model="mainledger.PayedVAT"></v-checkbox>
                  </v-col>
                  <v-col cols="12" sm="4" md="3" lg="3">
                    <v-checkbox dense hide-details class="mt-0" :label="lang.partnerNotInVAT" v-model="mainledger.partnerNotInVAT"></v-checkbox>
                  </v-col>
                  <v-col cols="12" sm="6" md="3" lg="3">
                    <v-text-field outlined dense hide-details label="PPO samo za TU" v-model.number="mainledger.FreeF2" type="number"></v-text-field>
                  </v-col>
                </v-row>

              </v-card-text>
            </v-card>

            <!-- VEZA I SKLADIŠTE -->
            <v-card outlined class="mb-4">
              <v-card-title class="naslov-kartice">
                Veza i skladište
              </v-card-title>
              <v-card-text class="pt-2 pb-1">
                <v-btn text small color="primary" class="pl-0" @click="otvorenoVeza = !otvorenoVeza" v-if="!prikaziVezu || !otvorenoVeza">
                  <v-icon small>{{ prikaziVezu ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                  Veza s dokumentom, otpremnica, primka
                </v-btn>

                <v-row dense v-if="prikaziVezu" class="mt-2">
                  <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                    <v-text-field outlined hide-details="auto" dense :label="lang.ConnName" v-model="mainledger.ConnName"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="2" class="pr-3">
                    <v-text-field outlined hide-details="auto" dense :label="lang.ConnId" v-model="mainledger.ConnId"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="2" class="pr-3">
                    <v-text-field outlined hide-details="auto" dense label="Broj otpremnice" v-model="mainledger.DeliveryNoteNumber"></v-text-field>
                  </v-col>
                </v-row>
                <v-row dense v-if="prikaziVezu && mainledger.BookTypeID === 1">
                  <v-col cols="12" sm="6" md="3" lg="2" class="pr-3">
                    <v-text-field outlined hide-details="auto" dense label="Broj skladista" v-model.number="mainledger.WareHouseId" type="number"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3" lg="2" class="pr-3">
                    <v-text-field outlined hide-details="auto" dense label="Broj primke" v-model.number="mainledger.WareHouseEntry" type="number"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3" lg="2" class="pr-3">
                    <v-text-field outlined hide-details="auto" dense label="Iznos primke" v-model.number="mainledger.WareHouseEntryAmount" type="number"></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

          </v-form>
          <div class="pink" v-html="error" />

          <!-- Zbrojevi i radnje su uvijek na dnu ekrana, da se ne mora skrolati
               do dna za provjeru slaze li se iznos. -->
          <div class="podnozje-dok">
            <div class="stavka">
              <span>Iznos računa</span>
              <b>{{ localMoney(mainledger.InvoiceAmount) }}</b>
            </div>
            <div class="stavka">
              <span>Osnovica</span>
              <b>{{ localMoney(mainledger.AmountNetto) }}</b>
            </div>
            <div class="stavka">
              <span>PDV</span>
              <b>{{ localMoney(mainledger.AmountVAT) }}</b>
            </div>
            <div class="stavka">
              <span>Odbitni PDV</span>
              <b>{{ localMoney(odbitniPdvUkupno) }}</b>
            </div>
            <v-spacer></v-spacer>
            <!-- Kanta stoji na dnu, odmaknuta od gumba koji se koriste svaki
                 dan - na vrhu kartice "Dokument" bila je nadohvat ruke, a
                 brise privitke. -->
            <span v-if="this.$store.state.editItem === 1">
              <v-btn text small color="red darken-1" class="mr-4" @click="confirmDelete" title="Obriši privitke">
                <v-icon small>mdi-trash-can</v-icon>
              </v-btn>
            </span>
            <v-btn
              class="primary mr-1"
              :disabled="!formIsValid"
              @click="beforeRegister" >
              PROKNJIŽI
            </v-btn>
            <span v-if="this.$store.state.editItem === 0">
              <v-btn
                class="primary mr-1"
                @click="mainledgeragain">
                OTVORI NOVI
              </v-btn>
            </span>
            <v-btn
              color="green"
              @click="mainledgerlist">
              <span v-if="this.$store.state.language == 'EN'">
              Back
              </span>
              <span v-if="this.$store.state.language == 'HR'">
              Natrag
              </span>
            </v-btn>
          </div>

          <!-- <MainLedgerUpload v-if="showUpload" :mainledger="mainledger"></MainLedgerUpload> -->
          <!-- <showImage64 v-if="showUploadImg"  :base64Content="base64Content" /> -->
          <DocumentPDFPreview v-if="showPDFhere" :fullpath="fullpath" />

      </v-col>
    </v-row>

    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      bottom
      :color="color"
      >
      {{ text }}
    </v-snackbar>
  </v-container>
</template>

<script>
import PartnerService from '@/services/PartnerService'
import SudRegService from '@/services/SudRegService'
import { popuni as popuniIzRegistra, opis as opisRegistra } from '@/snippets/sudregPopuna'
import PartnerCompanyService from '@/services/PartnerCompanyService'
import MainLedgerService from '@/services/MainLedgerService'
import MainLedgerDetailService from '@/services/MainLedgerDetailService'
import BankAccountService from '@/services/BankAccountService'
import BankOrderService from '@/services/BankOrderService'
import Api from '@/services/Api'
import ledgerEN from './MainLedgerDescEN'
import ledgerHR from './MainLedgerDescHR'
import commEn from "@/language/commonEN"
import commHr from "@/language/commonHR"
import { defNew, defMainQuery, defMainLedger, defNewpartner, defMainLedgerDetailFill } from './mainledgerHelper'
import { testLastUpdate, newUpdates } from '@/services/TestLastUpdate'
import MainLedgerUpload from './MainLedgerUpload'
import showImage64 from '../../snippets/showImage64.vue'
import {parseNum, round, dateFormat, createFloat} from '@/snippets/allSnippets'
import moneyFormat from '@/snippets/moneyFormat'
import {defBankOrder, defNewBankOrder} from '../Salarie/salarieHelper'
import dayjs from 'dayjs'
import {nacini, nacinPoOznaci, nacinIzSifre} from './nacinPlacanja'
import DocumentPDFPreview from '../Document/DocumentPDFPreview'
//mport FileSaver from 'file-saver'

// import dateFormat from '@/snippets/dateFormat'

export default {
  name: 'mainledgercreate',
  data () {
    return {
      admin: false,
      snackbar: false,
      text: '',
      timeout: 2000,
      color: 'green',
      lang: {},
      langC: {},
      valid: true,
      lazy: false,
      rules: {
        required: value => !!value || '*'
      },
      menu: false,
      menu2: false,
      menu3: false,
      dateFormatted: null,
      dateFormatted2: null,
      modal: false,
      date1: null,
      date2: null,
      modal1: false,
      modal2: false,
      modal3: false,
      modal4: false,
      dialog1: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,
      msg: '',
      documentName: '',
      documentNameLoc: '',
      mainledger: { },
      error: null,
      localError: false,
      newDocument: {},
      confpassword: '',
      size: 'sm',
      required: (value) => !!value || 'Required.',
      partners: [],
      employes: [],
      banks: [],
      currnecy: [],
      users: [],
      CompanyId: 0,
      selectPa: {},
      naciniPlacanja: nacini(),
      punjenjeRacuna: false,
      urediPartnera: false,
      mijenjamPartnera: false,
      otvorenoOslobodjenja: false,
      otvorenoDobraUsluge: false,
      otvorenoVeza: false,
      otvorenoUvoz: false,
      rucnoPdv13: false,
      rucnoPdv5: false,
      rucnoOstaloPdv: false,
      nacinPlacanjaOznaka: 'transakcijski',
      selectBank: {},
      selectCR: {},
      selectUs: {},
      mainQuery: {
        CompanyId: 1,
        BusinessYear: 0,
        documentName: '',
        MLType: 0
      },
      currnecyType: [
        { text: 'EUR', value: 'EUR' },
        { text: 'Kn', value: 'Kn' },
        { text: 'USD', value: 'USD' },
        { text: 'GBP', value: 'GBP' },
        { text: 'CHF', value: 'CHF' }
      ],
      money: {
        prefix: '= ',
        suffix: ' ',
        precision: 3
      },
      price: 7.500,
      localUser: '',
      bookType: [],
      bookTypeSelected: {
      },
      bookSubType: [],
      bookSubTypeSelected: {},
      showUpload: false,
      haveItem: null,
      selectId: null,
      haveNew: false,
      show: 1,
      mainQuery3: {},
      dog: 0,
      InvoiceAmount: 0,
      savedML: null,
      mldetails: [],
      BusinessYear: 2020,
      showOut: false,
      viewShowOut: false,
      show2Dcode: true,
      
      txt2Dcode: '',
      fileEInvoice: '',
      show2DcodeName: false,
      
      somefile: null,
      MLFree2: null,
      MLFree3: null,
      MLFree4: null,
      MLFree5: null,
      showVAT: true,
      locBookID : 0,

      showERacun: true,
      showUploadERacun: false,
      haveeRacun: false,

      havePDF: false,
      showUploadPDF: false,
      showPDF: true,

      haveImg: true,
      base64Content : null,
      showUploadPDF: false, 
      doc64: null,
      haveDoc64: false,
      fullpath: null,
      showPDFhere: false,
      alreadyInBooks: false
    }
  },
  components: {
   MainLedgerUpload,
   showImage64,
   DocumentPDFPreview
  },
  async mounted () {
    if (this.$store.state.language === "EN") {
      this.lang = ledgerEN
      this.langC = commEn;
    }
    if (this.$store.state.language === "HR") {
      this.lang = ledgerHR
      this.langC = commHr;
    }
    const d = new Date()
    this.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : d.getFullYear()

    if (this.$store.state.user.Admin) {
      this.admin = this.$store.state.user.Admin
    }
    this.documentName = this.$store.state.documentActiv
    this.documentNameLoc = this.$store.state.documentActivLoc
    if (this.$store.state.companyid) {
      this.CompanyId = this.$store.state.companyid
      this.mainQuery3.CompanyId = this.$store.state.companyid
    }
    if (this.CompanyId > 0) {
      //await checkPartners(0)
      await testLastUpdate()
      if (this.$store.state.partnerStore) {
        this.partners = this.$store.state.partnerStore
      }
      //this.partners = (await PartnerService.index()).data.partners
    }
    this.show = 1
    if (this.$store.state.documentSide === 1 || this.$store.state.documentSide === 2) {
      this.show = 1
      if (this.$store.state.documentSide === 2) {
        this.viewShowOut = true
      }
    }
    if (this.$store.state.documentSide === 3) {
      this.show = 3
    }
    if (this.$store.state.documentSide === 4) {
      this.show = 4
    }
    this.bookType = this.$store.state.booktype ? this.$store.state.booktype : []
    this.bookSubType = this.$store.state.booksubtype ? this.$store.state.booksubtype : []
    this.banks = (await BankAccountService.choose(this.mainQuery)).data.bankAccounts
    this.selectBank = this.banks ? this.banks.find(bank => (bank.DefaultAccount === true)) : {}

    // if (this.$store.state.editItem === 0) {
    //   this.mainledger = defMainLedger()
    //   this.mainledger = {...this.mainledger, ...defNew()}
    //   this.mainQuery = {...defMainQuery()}
    //   this.localUser = this.mainledger.First + ' ' + this.mainledger.Last + ', ' + this.mainledger.email
    //   this.haveNew = true
    //   this.bookTypeSelected  = this.$store.state.bookTypeSelected
      
    // }
    if (this.$store.state.editItem === 1) {
      const locDocument = await MainLedgerService.show(this.$store.state.mainledgerid)
      this.mainledger = locDocument.data.mainLedger
      this.InvoiceAmount = this.mainledger.InvoiceAmount ? parseFloat(this.mainledger.InvoiceAmount) : 0
      this.locBookID = parseInt(this.mainledger.BookID)
      // Broj knjizenja iz baze stize kao "1.00" - u obrascu mora biti cijeli broj.
      this.mainledger.BookID = parseInt(this.mainledger.BookID) || 0
      // Partner se trazi po OIB-u, ne po id-u. Isti partner je pod svakom firmom
      // upisan kao zaseban redak sa svojim id-em, pa id s racuna cesto pokazuje na
      // redak druge firme i trazenje po njemu ne uspije. Prije se tada partnerId
      // postavljao na null, promatrac je obrisao SVE podatke o partneru s racuna,
      // a spremanje ih je upisalo prazne. Ako partnera nema u listi, stavka se
      // sastavi iz podataka koje racun vec nosi - nista se ne gubi.
      this.punjenjeRacuna = true
      let finded = false
      if (this.mainledger.partnerVATID) {
        this.selectPa = this.partners.find(partner => this.istiOIB(partner.partnerVATID, this.mainledger.partnerVATID))
        if (this.selectPa) {
          finded = true
          this.mainledger.partnerId = this.selectPa.id
        }
      }
      if (!finded && this.mainledger.partnerId) {
        this.selectPa = this.partners.find(partner => (partner.id === parseInt(this.mainledger.partnerId)))
        if (this.selectPa) {
          finded = true
        }
      }
      if (!finded) {
        this.selectPa = this.partnerSRacuna()
        if (this.selectPa) {
          this.partners = [this.selectPa, ...this.partners]
        }
      }
      this.$nextTick(() => { this.punjenjeRacuna = false })
      this.bookTypeSelected = this.mainledger.BookTypeID ? this.$store.state.booktype.find(book => (parseInt(book.value) === this.mainledger.BookTypeID )) : null
      this.bookSubTypeSelected = this.mainledger.BookSubTypeID ? this.bookSubType.find(book => (parseInt(book.value) === this.mainledger.BookSubTypeID )) : null
      this.haveNew = false
      this.doParse()
    }
    
    // if (this.$store.state.booktype) {     
    //   this.bookType = this.$store.state.booktype.filter(book => {
    //         return book.side === this.$store.state.documentSide
    //       })
    //   this.bookTypeSelected = this.mainledger.BookTypeID ? this.bookType.find(book => (parseInt(book.value) === this.mainledger.BookTypeID )) : null
    // }

    if (this.mainledger.filexml_originalname && this.mainledger.filexml_originalname.length > 1) {
      this.haveeRacun = true
    }
    if (this.mainledger.MLFree2 && this.mainledger.MLFree2.length > 1) {
      this.havePDF = true
    }
    this.setBookSubTypes()
    this.bookSubTypeSelected = this.mainledger.BookSubTypeID ? this.bookSubType.find(book => (parseInt(book.value) === this.mainledger.BookSubTypeID )) : null
    this.$refs.bookingd.focus()
  },
  computed: {
    // Ucitavanje eSLOG racuna vidi samo firma kojoj taj posrednik salje.
    // Ostalima se ponasa kao prije: takav XML se odbija.
    dopustenEslog () {
      const c = this.$store.state.companyActiv
      return !!(c && c.CompanyEslogImport === true)
    },
    // Odjeljci stoje sklopljeni dok su prazni; cim neko polje u njima ima
    // vrijednost, otvore se sami pri otvaranju racuna.
    prikaziOslobodjenja () {
      const ml = this.mainledger
      // VAT4PerCanUse i VAT5PerCanUse nose zadanih 100 na 80 % racuna, pa nisu
      // znak da je oslobodjenje upisano - inace bi se odjeljak otvarao uvijek.
      return this.otvorenoOslobodjenja || this.showOut || this.imaNeki([
        ml.VAT4Per, ml.VAT4Base, ml.VAT4Amount, ml.VAT4CanUse, ml.VAT4CanTUse,
        ml.VAT5Per, ml.VAT5Base, ml.VAT5Amount
      ])
    },
    prikaziDobraUsluge () {
      const ml = this.mainledger
      return this.otvorenoDobraUsluge || ml.BookTypeID === 3 || ml.BookTypeID === 4 || this.imaNeki([
        ml.Goods, ml.Goods25, ml.Goods13, ml.Goods5, ml.Services, ml.Services25, ml.Services13, ml.Services5
      ])
    },
    odbitniPdvUkupno () {
      const ml = this.mainledger
      return (parseFloat(ml.VAT1CanUse) || 0) + (parseFloat(ml.VAT2CanUse) || 0) + (parseFloat(ml.VAT3CanUse) || 0)
    },
    prikaziUvoz () {
      const ml = this.mainledger
      return this.otvorenoUvoz || ml.MLBool1 === true || ml.PayedVAT === true ||
        ml.partnerNotInVAT === true || this.imaNeki([ml.FreeF2])
    },
    prikaziVezu () {
      const ml = this.mainledger
      return this.otvorenoVeza || this.imaNeki([
        ml.ConnName, ml.ConnId, ml.DeliveryNoteNumber,
        ml.WareHouseId, ml.WareHouseEntry, ml.WareHouseEntryAmount
      ])
    },
    // Spojnica ide samo izmedju podataka kojih doista ima, da redak ne pocne s tockom.
    partnerAdresaTxt () {
      const ml = this.mainledger
      const ulica = [ml.partnerStreet, ml.partnerBuildingNameNumber].filter(d => d).join(' ')
      const mjesto = [ml.partnerPostcode, ml.partnerCity].filter(d => d).join(' ')
      return [ml.partnerVATID ? 'OIB ' + ml.partnerVATID : '', ulica, mjesto].filter(d => d).join(' · ')
    },
    partnerKontaktTxt () {
      const ml = this.mainledger
      return [ml.partnerBankIBAN, ml.partneremail].filter(d => d).join(' · ')
    },
    // Izbornik partnera stoji samo dok partner nije odabran ili dok se mijenja.
    prikaziIzbornikPartnera () {
      return this.mijenjamPartnera || !this.mainledger.partnerName
    },
    // Podaci partnera stoje kao tekst; polja se otvaraju na "Uredi podatke",
    // a sama od sebe kad racun jos nema partnera (novi racun).
    prikaziPoljaPartnera () {
      return this.urediPartnera || !this.mainledger.partnerName
    },
    // Stope 13 % i 5 % te neoporezivo ne stoje prazne na ekranu. Prikazuju se
    // cim na racunu imaju upisanu vrijednost, ili kad ih korisnik sam otvori.
    prikaziPdv13 () {
      return this.rucnoPdv13 || this.imaIznos(this.mainledger.VAT2Base) || this.imaIznos(this.mainledger.VAT2Amount)
    },
    prikaziPdv5 () {
      return this.rucnoPdv5 || this.imaIznos(this.mainledger.VAT3Base) || this.imaIznos(this.mainledger.VAT3Amount)
    },
    prikaziOstaloPdv () {
      return this.rucnoOstaloPdv || this.imaIznos(this.mainledger.VAT4Base) || this.imaIznos(this.mainledger.VATZero)
    },
    formIsValid () {
      return this.mainledger.email !== '' &&
        this.mainledger.First !== '' &&
        this.mainledger.Last !== '' &&
        this.mainledger.InvoiceDate !== '' &&
        this.mainledger.BookingDate !== '' 
    },
    formatDate1() {
      return this.mainledger.BookingDate
        ? dateFormat(this.mainledger.BookingDate)
        : "";
    },
    formatDate2() {
      return this.mainledger.InvoiceDate
        ? dateFormat(this.mainledger.InvoiceDate)
        : "";
    },
    formatDate3() {
      return this.mainledger.InvoicePaymentDeadlineDate
        ? dateFormat(this.mainledger.InvoicePaymentDeadlineDate)
        : "";
    },
    formatDateE(eDate) {
      return eDate
        ? dateFormat(eDate)
        : "";
    },
    // formatDate4() {
    //   return this.mainledger.paidDate
    //     ? dateFormat(this.mainledger.paidDate)
    //     : "";
    // }
  },
  methods: {
    getRndInteger(min, max) {
      return Math.floor(Math.random() * (max - min) ) + min;
    },
    showOut1() {
      this.showOut = !this.showOut
    },
    setBookSubTypes() {
      
    },
    onDownload() {
      // download xml
    },
    switchVAT() {
      this.showVAT = !this.showVAT
    },
    load2Dcode() {
      this.show2Dcode = false
      this.showERacun = false
      this.show2DcodeName = true
      this.showUploadERacun = false
    },
    loadeInvoice() {
      this.show2Dcode = false
      this.showERacun = false
      this.show2DcodeName = false
      this.showUploadERacun = true
    },
    loadPDF() {
      this.showPDF = false
      this.showUploadPDF = true
    },
    async confirmDelete() {
      if (confirm('Upozorenje. Želite li obrisati privitke? Warning. You will delete attachments? ')) {
          await this.deleteAttach()
        }
    },
    async deleteAttach() {
      this.mainledger.filex
      try {
        this.mainledger.filexml_originalname = null
        this.mainledger.filexml_filename = null
        this.mainledger.filexml_destination = null
        this.mainledger.filexml_path = null
        this.mainledger.filexml_mimetype = null

        this.mainledger.MLFree2 = null
        this.mainledger.MLFree3 = null
        this.mainledger.MLFree4 = null
        this.mainledger.MLFree5 = null
       
        await MainLedgerService.put(this.mainledger).then(res => {
          this.text = 'Skenirani dokument je snimljen' + res.data.message
          this.color = 'green'
          this.snackbar = true
          this.showERacun =  true
          this.showUploadERacun = false
          this.haveeRacun = false

          this.havePDF = false
          this.showUploadPDF =false
          this.showPDF = true
          
        }).catch(error => {
          this.text = 'Error ' + error
          this.color = 'red'
          this.snackbar = true
        })         
      } catch (error) {
        this.text = 'Error ' + error
        this.color = 'red'
        this.snackbar = true
      }
     
    },
    convertToDate(dateString) {
      // Check if the input is a non-empty string
      if (typeof dateString !== 'string' || dateString.length === 0) {
        return null;
      }

      // Split the string into components
      const parts = dateString.split('-');

      // Basic check for the correct number of parts
      if (parts.length !== 3) {
        return null;
      }

      // Destructure the parts and convert them to numbers
      const [yearStr, monthStr, dayStr] = parts;
      const year = parseInt(yearStr, 10);
      // Month is 0-indexed in the Date constructor (0 for January, 11 for December)
      const month = parseInt(monthStr, 10) - 1;
      const day = parseInt(dayStr, 10);
  

      // Check if parsing resulted in valid numbers
      if (isNaN(year) || isNaN(month) || isNaN(day)) {
        return null;
      }

      // Create the Date object using the UTC version of the constructor to avoid local timezone issues
      // The format 'YYYY-MM-DD' is specifically handled by the Date.parse() or Date()
      // constructor and is interpreted as UTC, which is generally safer for date-only values.
      const date = new Date(year, month, day);

      // A final validation: check if the created date is a valid date
      // (e.g., prevents dates like '2023-02-30' from being created)
      if (isNaN(date.getTime())) {
        return null;
      }

      return date;
    },
    onUploadPDF() {
      if (this.somefile && this.somefile.type === 'application/pdf') {
        const newId = this.getRndInteger(100000, 900000)
        let fd = new FormData()
        fd.append('companyId', this.$store.state.companyid)
        fd.append('newId', newId)
        fd.append('originalName', this.somefile.name)
        fd.append('typeDoc', 'BI')
        fd.append('myFile', this.somefile, this.somefile.name)
        Api().post('bookin/invoice', fd).then(response => {
            this.data = response.data
             if (this.data) {
                this.mainledger.MLFree2 = this.data.originalname ? this.data.originalname : ''
                this.mainledger.MLFree3 = this.data.filename ? this.data.filename : ''
                this.mainledger.MLFree4 = this.data.destination ? this.data.destination : ''
                this.mainledger.MLFree5 = this.data.path ? this.data.path : ''
                this.havePDF = true
                this.updateMl()
            }
        }).catch(error => {
            this.text = 'Error ' + error
            this.color = 'red'
            this.snackbar = true
            if (error.response.status === 422) {
                this.errors = error.response.data.errors || {};
            }
        });
      } else {

      }
    },
    async updateMl() {
      try {
        await MainLedgerService.put(this.mainledger).then(res => {
          this.text = 'Skenirani dokument je snimljen' + res.data.message
          this.color = 'green'
          this.snackbar = true
          
        }).catch(error => {
          this.text = 'Error ' + error
          this.color = 'red'
          this.snackbar = true
        })         
      } catch (error) {
        this.text = 'Error ' + error
        this.color = 'red'
        this.snackbar = true
      }
    },
    onDownloadPDF() {
      console.log('onDownloadPDF')
    },
    openPDF() {
      if (this.mainledger.MLFree5) {
        console.log('2 otvaram sliku u privitku', this.mainledger.MLFree5)
        this.fullpath =  this.mainledger.MLFree5
        this.showPDFhere = true
      }
    },
    // Prepisuje racun procitan iz eSLOG-a u polja knjige URA.
    //
    // Posluzitelj je XML vec razlozio (helpers/eslogRacun.js), pa se ovdje
    // ne kopa po EDIFACT segmentima - samo se popunjava i provjerava postoji
    // li racun vec u knjizi.
    async ucitajEslog (eslog) {
      const r = eslog.racun
      const d = r.dobavljac || {}

      const findWhat = {
        CompanyId: this.$store.state.companyid ? this.$store.state.companyid : 1,
        BusinessYear: this.$store.state.businessYear ? this.$store.state.businessYear : 2021,
        MLType: 1,
        InvoiceNumber: r.broj,
        partnerVATID: d.oib
      }
      await this.checkIfExist(findWhat)
      if (this.alreadyInBooks) {
        this.text = 'Greska! URA sa tim brojem već postoji u knjizi URA. Error! Invoice with this number already exist in books! '
        this.color = 'red'
        this.snackbar = true
        this.showUploadERacun = false
        this.showERacun = true
        this.haveeRacun = false
        return
      }

      this.mainledger.InvoiceNumber = r.broj
      this.mainledger.InvoiceDate = r.datum ? r.datum : null
      // Knjizi se po datumu za porez; ako ga nema, po datumu isporuke, pa po
      // datumu dokumenta.
      this.mainledger.BookingDate = r.datumZaPorez || r.datumIsporuke || r.datum || null
      this.mainledger.InvoicePaymentDeadlineDate = r.dospijece ? r.dospijece : null

      this.mainledger.partnerName = d.naziv
      this.mainledger.partnerVATID = d.oib
      this.mainledger.partnerStreet = d.ulica
      this.mainledger.partnerCity = d.grad
      this.mainledger.partnerPostcode = d.posta
      if (d.email) { this.mainledger.partneremail = d.email }
      if (d.iban) { this.mainledger.partnerBankIBAN = d.iban }

      // Odobrenje (BGM 381) ima obrnuti predznak.
      const predznak = r.odobrenje ? -1 : 1
      this.mainledger.InvoiceAmount = round(r.iznos * predznak, 2)

      // Firma koja nije u sustavu PDV-a ne razvrstava porez - isto pravilo
      // kao kod UBL-a.
      if (this.$store.state.companyActiv.notinVAT === false) {
        const polja = eslog.poljaURA || {}
        Object.keys(polja).forEach(k => {
          this.mainledger[k] = typeof polja[k] === 'number'
            ? round(polja[k] * predznak, 2) : polja[k]
        })
      }

      if (r.pozivNaBroj) { this.mainledger.MLFree1 = r.pozivNaBroj }

      // Partner MORA biti odabran: "register" cita "this.selectPa.partnerVATID"
      // i bez toga puca prije nego zahtjev uopce ode na posluzitelj - racun se
      // ucita, a knjizenje javi "Cannot save document".
      let nasao = null
      if (this.mainledger.partnerVATID && this.partners && this.partners.length) {
        nasao = this.partners.find(x => this.istiOIB(x.partnerVATID, this.mainledger.partnerVATID))
      }
      if (nasao) {
        this.selectPa = nasao
        this.mainledger.partnerId = nasao.id
      } else {
        // Partnera nema u sifrarniku - sastavi se iz podataka koje racun nosi.
        this.selectPa = this.partnerSRacuna()
        if (this.selectPa) { this.partners = [this.selectPa, ...this.partners] }
      }
      if (!this.selectPa) { this.selectPa = {} }

      this.haveeRacun = true
      this.showUploadERacun = false
      this.showERacun = true
      this.text = 'Učitan eSLOG račun ' + r.broj + ', ' + d.naziv +
        (r.porezi.some(x => x.prijenosObveze) ? ' (prijenos porezne obveze)' : '')
      this.color = 'green'
      this.snackbar = true
    },
    async checkIfExist(findWhat) {
        // when enter NEW invoice check if already exist with these number
        const res = await MainLedgerService.find(findWhat)
        if (res.data && res.data.mainLedger && res.data.mainLedger.length > 0) {
          this.alreadyInBooks = true
        }
    },
    extractNameAndBase64FromDataUrl (xmlString){
      const filenameMatch = xmlString.match(/filename="([^"]+)"/i);
      const contentMatch = xmlString.match(/>([^<]+)</);

      // 2. Critical Check: Ensure we actually found the data
      if (!filenameMatch || !filenameMatch[1]) {
        throw new Error("Could not find 'filename' attribute in the string.");
      }
      if (!contentMatch || !contentMatch[1]) {
        throw new Error("Could not find Base64 content inside the XML tags.");
      }

      const fileName = filenameMatch[1];
      const base64Data = contentMatch[1].trim();
      const fileAndData = {
        fileName,
        base64Data
      }
     // const match = str.match(/name=([^;]+)/);
      return fileAndData
    },
    onUpload() {
        this.MLFree2 = ''
        this.MLFree3 = ''
        this.MLFree4 = ''
        this.MLFree5 = ''
        this.alreadyInBooks = false
        console.log('this.somefile', this.somefile)
        if (this.somefile && this.somefile.type === 'text/xml') {
          let fd = new FormData()
          fd.append('companyId', this.$store.state.companyid)
          fd.append('originalName', this.somefile.name)
          fd.append('typeDoc', 'eRacun')
          fd.append('myFile', this.somefile, this.somefile.name)
          this.somefile = null

          Api().post('bookin/invoice', fd).then(async(response) => {
              this.data = response.data
              if (this.data) {

                this.mainQuery.MLFree2 = this.data.originalname ? this.data.originalname : ''
                this.mainQuery.MLFree3 = this.data.filename ? this.data.filename : ''
                this.mainQuery.MLFree4 = this.data.destination ? this.data.destination : ''
                this.mainQuery.MLFree5 = this.data.path ? this.data.path : ''

                this.mainledger.filexml_originalname = this.data.originalname ? this.data.originalname : ''
                this.mainledger.filexml_filename = this.data.filename ? this.data.filename : ''
                this.mainledger.filexml_destination = this.data.destination ? this.data.destination : ''
                this.mainledger.filexml_path = this.data.path ? this.data.path : ''
                this.mainledger.filexml_mimetype = this.data.mimetype ? this.data.mimetype : ''
                this.haveeRacun = true
                if (this.data.mimetype ===  'text/xml') {
                  await MainLedgerService.readxmleracun(this.mainQuery)
                  .then (async(res) => {
                    const data = res && res.data ? res.data : {}

                    // eSLOG 2.00 - jedan informacijski posrednik ne salje UBL.
                    // Posluzitelj ga je vec procitao u gotov oblik; ovdje se
                    // samo prepise u polja. Ostali korisnici ovo ne vide:
                    // dok firma nema ukljucen "CompanyEslogImport", takav
                    // racun se odbija kao i prije.
                    if (data.eslog) {
                      if (!this.dopustenEslog) {
                        this.text = 'Ovaj XML nije eRačun (format eSLOG). Učitavanje tog formata nije uključeno za ovu firmu.'
                        this.color = 'red'
                        this.snackbar = true
                        this.haveeRacun = false
                        return
                      }
                      if (!data.eslog.ok) {
                        this.text = 'Greška kod čitanja eSLOG računa: ' + data.eslog.greska
                        this.color = 'red'
                        this.snackbar = true
                        this.haveeRacun = false
                        return
                      }
                      await this.ucitajEslog(data.eslog)
                      return
                    }

                    const preInv = data.jObj ? data.jObj : null
                    let inv = null
                    if (preInv && preInv.Invoice) {
                      inv = preInv.Invoice
                    }
                    if (preInv && preInv['inv:Invoice']) {
                      inv = preInv['inv:Invoice'] 
                    }
                    if (preInv && preInv['ubl:Invoice'] ) {
                      inv = preInv['ubl:Invoice'] 
                    }
                    if (preInv && preInv.CreditNote) {
                      inv = preInv.CreditNote
                    }
                    if(Object.keys(inv).length === 0 ){
                      alert('ERROR! Error on loading document! Greška kod učitavanja dokumenta!')
                      return
                    }
                    // when enter NEW invoice check if already exist with these number
                    const aSpT = inv['cac:AccountingSupplierParty']
                      const PartyT = aSpT['cac:Party']
                        const PartyTaxSchemeT = PartyT['cac:PartyTaxScheme']

                    const findWhat = {}
                    findWhat.CompanyId  = this.$store.state.companyid ? this.$store.state.companyid : 1
                    findWhat.BusinessYear =  this.$store.state.businessYear ? this.$store.state.businessYear : 2021
                    findWhat.MLType = 1
                    findWhat.InvoiceNumber = inv['cbc:ID'] ? inv['cbc:ID'] : ''
                    findWhat.partnerVATID = typeof PartyTaxSchemeT['cbc:CompanyID'] === 'string' ? PartyTaxSchemeT['cbc:CompanyID'].trim().substr(2,11) : PartyTaxSchemeT['cbc:CompanyID']
                    
                    await this.checkIfExist(findWhat)
                    if (this.alreadyInBooks) {
                      this.text = 'Greska! URA sa tim brojem već postoji u knjizi URA. Error! Invoice with this number already exist in books! '
                      this.color = 'red'
                      this.snackbar = true
                      this.showUploadERacun = false
                      this.showERacun = true
                      this.haveeRacun =  false
                      return
                    }

                    const neRadi = false
                    // ---------------------------------------------------------   Privitak
                    if (inv['cac:AdditionalDocumentReference']) {
                      console.log('1 imam privitak')
                      const att1 = inv['cac:AdditionalDocumentReference'] ? inv['cac:AdditionalDocumentReference'] : null
                      let haveIDdoc = null
                      if (att1['cac:ID']){
                        haveIDdoc = att1['cac:ID']
                      }
                      console.log('2 imam privitak', att1)
                      const attOne = Array.isArray(att1) ? att1[0] : att1;
                      console.log('2.1 uzimam samo prvi ako je niz ', attOne)
                      if (attOne){
                        
                        const att2 = attOne['cac:Attachment']
                        
                        if (att2['cbc:EmbeddedDocumentBinaryObject']){
                          console.log('3 imam privitak')
                          this.haveImg = true
                          this.doc64 = att2['cbc:EmbeddedDocumentBinaryObject']
                          console.log('4 imam privitak', this.doc64.length, typeof this.doc64)
                          
                          const newId = this.getRndInteger(100000, 900000)
                          const fAttachment = {}
                          fAttachment.CompanyId  = this.$store.state.companyid ? this.$store.state.companyid : 1
                          fAttachment.BusinessYear =  this.$store.state.businessYear ? this.$store.state.businessYear : 2021
                          fAttachment.newId = newId
                          fAttachment.originalname = this.data.originalname
                          fAttachment.typeDoc = 'pdf'
                          fAttachment.destination = this.data.destination
                          fAttachment.ID = haveIDdoc ? haveIDdoc : ''
                          fAttachment.base64WithoutHeader = this.doc64

                          try {
                            console.log('saljem attach to backend')
                            const resAttach = await MainLedgerService.haveattach(fAttachment)
                            console.log('resAttach', resAttach)

                            this.mainledger.MLFree2 = this.data.originalname ? this.data.originalname : ''
                            this.mainledger.MLFree3 = haveIDdoc ? haveIDdoc : ''
                            this.mainledger.MLFree4 = this.data.destination ? this.data.destination : ''
                            this.mainledger.MLFree5 = resAttach.data.zoveSe ? resAttach.data.zoveSe : ''
                            this.havePDF = true

                          } catch (error) {
                            this.text = 'Greska! Kod snimanja privitka. Error! On save attachment! ' + error.data
                            this.color = 'red'
                            this.snackbar = true
                            this.showUploadERacun = false
                            this.showERacun = true
                            this.haveeRacun =  false
                            return
                          }
                          
                          //this.havePDF = true
                          this.haveDoc64 = true
                        }
                      }
                    }

                      

                    // ---------------------------------------------------------   Datumi
                    const prviD = dayjs(new Date()).format('YYYY-MM-DD')
                    const drugiD = dayjs(new Date()).format('YYYY-MM-DD')
                    const treciD = dayjs(new Date()).add(15, 'days').format('YYYY-MM-DD')

                    this.mainledger.InvoiceNumber = inv['cbc:ID'] ? inv['cbc:ID'] : ''
                    this.mainledger.InvoiceDate = null
                    this.mainledger.InvoicePaymentDeadlineDate = null
                    const prvi = inv['cbc:TaxPointDate'] ? dayjs(inv['cbc:TaxPointDate']).format('YYYY-MM-DD'): prviD
                    this.mainledger.BookingDate = prvi

                    const drugi = inv['cbc:IssueDate'] ? dayjs(inv['cbc:IssueDate']).format('YYYY-MM-DD'): drugiD
                    this.mainledger.InvoiceDate = drugi

                    const treci = inv['cbc:DueDate'] ? dayjs(inv['cbc:DueDate']).format('YYYY-MM-DD'): treciD
                    this.mainledger.InvoicePaymentDeadlineDate = treci


                    // ----------------------------------------------------  za KUPCA 
                    const aCp = inv['cac:AccountingCustomerParty']
                      const cParty = aCp['cac:Party']
                      let cName = null
                      let cName2 = null

                      const cPartyName = cParty['cac:PartyName'] ? cParty['cac:PartyName'] : null
                      if (cPartyName) {
                        cName = cPartyName['cbc:Name'] ? cPartyName['cbc:Name'] : null
                      }

                      const cPartyName2 = cParty['cac:PartyLegalEntity']
                      if (cPartyName2) {
                        cName2 = cPartyName2['cbc:RegistrationName']
                      }
                      const CompanyName = cName && cName.length > 0 ? cName : (cName2 && cName2.length > 0 ? cName2 :'')

                      const cPartyTaxScheme = cParty['cac:PartyTaxScheme']
                      const CompanyIDpartnerVATID = typeof cPartyTaxScheme['cbc:CompanyID'] === 'string' ? cPartyTaxScheme['cbc:CompanyID'].trim().substr(2,11) : cPartyTaxScheme['cbc:CompanyID']

                      if (this.$store.state.documentSide === 2) {
                        this.mainledger.partnerName = CompanyName
                        this.mainledger.partnerVATID = CompanyIDpartnerVATID
                        const PostalAddress = cParty['cac:PostalAddress']
                        this.mainledger.partnerCity = PostalAddress['cbc:CityName']
                        this.mainledger.partnerStreet = PostalAddress['cbc:StreetName']
                        this.mainledger.partnerPostcode = PostalAddress['cbc:PostalZone']
                        if (Party['cac:Contact']){
                          const partyContact = cParty['cac:Contact']
                          if (partyContact['cbc:ElectronicMail']){
                            this.mainledger.partneremail = partyContact['cbc:ElectronicMail']
                          }
                        }
                      }

                    // ----------------------------------------------------- Dobavljac 
                    const aSp = inv['cac:AccountingSupplierParty']
                      const Party = aSp['cac:Party']
                        const PartyName = Party['cac:PartyName'] ? Party['cac:PartyName'] : null
                        let Name = null
                        let Name2 = null
                        if (PartyName) {
                          Name = PartyName['cbc:Name'] ? PartyName['cbc:Name'] : null
                        }
                        const PartyName2 = Party['cac:PartyLegalEntity']
                        if (PartyName2) {
                          Name2 = PartyName2['cbc:RegistrationName']
                        }  
                        if (this.$store.state.documentSide === 1) {
                          this.mainledger.partnerName = Name && Name.length > 0 ? Name : (Name2 && Name2.length > 0 ? Name2 :'')

                          const PartyTaxScheme = Party['cac:PartyTaxScheme']
                          this.mainledger.partnerVATID = typeof PartyTaxScheme['cbc:CompanyID'] === 'string' ? PartyTaxScheme['cbc:CompanyID'].trim().substr(2,11) : PartyTaxScheme['cbc:CompanyID']
                          const PostalAddress = Party['cac:PostalAddress']
                          this.mainledger.partnerCity = PostalAddress['cbc:CityName']
                          this.mainledger.partnerStreet = PostalAddress['cbc:StreetName']
                          this.mainledger.partnerPostcode = PostalAddress['cbc:PostalZone']
                          if (Party['cac:Contact']){
                            const partyContact = Party['cac:Contact']
                            if (partyContact['cbc:ElectronicMail']){
                              this.mainledger.partneremail = partyContact['cbc:ElectronicMail']
                            }
                          }
                       }

                        const haveIt = await this.findByVATID()
                        console.log('PARTNER Imam ga haveIt  ? ', haveIt)
                        if (!haveIt) {
                          // add new partner
                          this.addeditPartner()
                        }

                      // ----------------------------------------------------- Novci
                      const LegalMonetaryTotal = inv['cac:LegalMonetaryTotal']

                      let haveAllAmount = LegalMonetaryTotal['cbc:PayableAmount'] ? LegalMonetaryTotal['cbc:PayableAmount'] : 0
                      if (haveAllAmount === 0) {
                        haveAllAmount = LegalMonetaryTotal['cbc:TaxInclusiveAmount'] ? LegalMonetaryTotal['cbc:TaxInclusiveAmount'] : 0
                      }
                      this.mainledger.InvoiceAmount = haveAllAmount

                      // ---- virman 
                      const PaymentMeans = inv['cac:PaymentMeans']
                      const PaymentMeansCode = PaymentMeans['cbc:PaymentMeansCode'] ? PaymentMeans['cbc:PaymentMeansCode'] : '' 
                      const InstructionNote = PaymentMeans['cbc:InstructionNote'] ? PaymentMeans['cbc:InstructionNote'] : '' // opis placanja
                      const PaymentID = PaymentMeans['cbc:PaymentID'] ? PaymentMeans['cbc:PaymentID'] : ''  // poziv na broj HR00 123456
                      const ziroRn = PaymentMeans['cac:PayeeFinancialAccount'] ? PaymentMeans['cac:PayeeFinancialAccount'] : ''
                      const PayeeFinancialAccount = ziroRn['cbc:ID'] ? ziroRn['cbc:ID'] : null
                      this.mainledger.partnerBankIBAN = PayeeFinancialAccount
                      const tax = inv['cac:TaxTotal']
                      const taxSubtotal = tax['cac:TaxSubtotal']
                      // napravi virman
                      // this.createBankOrder()

                      // ako  nije u sustavu PDVa nemoj ga niti ucitavati 
                      if (this.$store.state.companyActiv.notinVAT=== false) { 
                        if (Array.isArray(taxSubtotal)){
                          // ima vise poreznih stopa
                          taxSubtotal.map(tax => {
                            const taxCategory = tax['cac:TaxCategory']
                            const taxVATPer = taxCategory['cbc:Percent'] ? taxCategory['cbc:Percent'] : 0
                            const TaxAmount = taxVATPer > 0 ? tax['cbc:TaxAmount'] : 0
                            const TaxableAmount = tax['cbc:TaxableAmount'] > 0 ? tax['cbc:TaxableAmount'] : 0
      
                            if (taxVATPer === 25) {
                              this.mainledger.VAT1Amount = round(TaxAmount,2)
                              this.mainledger.VAT1PerCanUse = 100
                              this.mainledger.VAT1CanUse = round(TaxAmount,2)
                              this.mainledger.VAT1CanTUse = 0
                              this.mainledger.VAT1Base = round(TaxableAmount ,2)
                            }
                            if (taxVATPer === 13) {
                              this.mainledger.VAT2Amount = round(TaxAmount,2)
                              this.mainledger.VAT2PerCanUse = 100
                              this.mainledger.VAT2CanUse = round(TaxAmount,2)
                              this.mainledger.VAT2CanTUse = 0
                              this.mainledger.VAT2Base = round(TaxableAmount ,2)
                            }
                            if (taxVATPer === 5) {
                              this.mainledger.VAT3Amount = round(TaxAmount,2)
                              this.mainledger.VAT3PerCanUse = 100
                              this.mainledger.VAT3CanUse = round(TaxAmount,2)
                              this.mainledger.VAT3CanTUse = 0
                              this.mainledger.VAT3Base = round(TaxableAmount ,2)
                            }
                            if (taxVATPer === 0) {
                              this.mainledger.VAT4Base = round(TaxableAmount,2)
                            }
                          })
                        }
                        if (!Array.isArray(taxSubtotal)){
                          // ima jednu poreznu stopu
                          const taxCategory = taxSubtotal['cac:TaxCategory']
                          const taxVATPer = taxCategory['cbc:Percent']
                          const TaxAmount = taxSubtotal['cbc:TaxAmount']
                          const TaxableAmount = taxSubtotal['cbc:TaxableAmount']
                          if (taxVATPer === 25) {
                            this.mainledger.VAT1Amount = round(TaxAmount,2)
                            this.mainledger.VAT1PerCanUse = 100
                            this.mainledger.VAT1CanUse = round(TaxAmount,2)
                            this.mainledger.VAT1CanTUse = 0
                            this.mainledger.VAT1Base = round(TaxableAmount ,2)
                          }
                          if (taxVATPer === 13) {
                            this.mainledger.VAT2Amount = round(TaxAmount,2)
                            this.mainledger.VAT2PerCanUse = 100
                            this.mainledger.VAT2CanUse = round(TaxAmount,2)
                            this.mainledger.VAT2CanTUse = 0
                            this.mainledger.VAT2Base = round(TaxableAmount ,2)
                          }
                          if (taxVATPer === 5) {
                            this.mainledger.VAT3Amount = round(TaxAmount,2)
                            this.mainledger.VAT3PerCanUse = 100
                            this.mainledger.VAT3CanUse = round(TaxAmount,2)
                            this.mainledger.VAT3CanTUse = 0
                            this.mainledger.VAT3Base = round(TaxableAmount ,2)
                          }
                        }
                      }
                      this.calculateVATAmount()
                      this.updateMl()
                  })
                  .catch(err => {
                    console.log('Greska ', err )
                    this.text = 'Error! Greška! Error on loading. Greska kod ucitavanja!' + (err ? err : '')
                    this.color = 'red'
                    this.snackbar = true
                    this.timeout = 4000
                  })
                }
              }
          }).catch(error => {
              console.log('Error uplodad ', error)
              alert(this.lang.alertError1)
              if (error.response.status === 422) {
                  this.errors = error.response.data.errors || {};
              }
          });

        } else {
          this.text = 'Error! Greška! Ovo nije xml datoteka!, This is not xml file!'
          this.color = 'red'
          this.snackbar = true
          this.timeout = 4000
        }
    },
    write2Dcode() {
      const lines = this.txt2Dcode.split('\n')
      console.log('lines', lines)
      if (lines[9] && lines[9].length > 0) {
        this.checkByIban2(lines[9].trim())
      }
      if(lines[1] && lines[2]) {
        this.mainledger.HomeCurrency = lines[1]
        this.mainledger.InvoiceAmount = createFloat(lines[2].trim())
        this.mainledger.VAT1Amount = round((this.mainledger.InvoiceAmount - round((this.mainledger.InvoiceAmount / 1.25) ,2)),2)
        this.mainledger.VAT1PerCanUse = 100
        this.mainledger.VAT1CanUse = round(this.mainledger.VAT1Amount,2)
        this.mainledger.VAT1CanTUse = 0
        this.mainledger.VAT1Base = round((this.mainledger.InvoiceAmount - this.mainledger.VAT1Amount) ,2)
        
      }
      // new fileds in mainledger for invoices. .. and new fields in bookorders
      if (lines[3]){
        this.mainledger.Pay1 = lines[10] ? lines[10] : ''
        this.mainledger.Pay2 = lines[11] ? lines[11] : ''
        this.mainledger.PayDesc = lines[13] ? lines[13] : ''
        
      }
    },
    async checkByIban2(iban) {
          if (iban){
            const cIban = {
              CompanyId : this.$store.state.companyid ? this.$store.state.companyid : 1,
              partnerBankIBAN: iban
            }

            this.error = null
            this.showPr = {}
            await PartnerService.checkIBAN(cIban)
            .then(res => {
              if (res.data.partner) {
                const pr = res.data.partner
                this.mainledger.partnerId = pr.id ? pr.id : null
                this.mainledger.partnerName = pr.partnerName ? pr.partnerName : null
                this.mainledger.partnerNameShort = pr.partnerNameShort ? pr.partnerNameShort : null
                this.mainledger.partnerNameDatabase = pr.partnerNameDatabase ? pr.partnerNameDatabase : null
                this.mainledger.partnerVATID = pr.partnerVATID ? pr.partnerVATID : null
                this.mainledger.partnerStreet = pr.partnerStreet ? pr.partnerStreet : null
                this.mainledger.partnerCity = pr.partnerCity ? pr.partnerCity : null
                this.mainledger.partnerPostcode = pr.partnerPostcode ? pr.partnerPostcode : null
                this.mainledger.partnerVATID = pr.partnerVATID ? pr.partnerVATID : null
                this.mainledger.partneremail = pr.partneremail ? pr.partneremail : null
                this.mainledger.partnerPhones = pr.partnerPhones ? pr.partnerPhones : null
                this.mainledger.partnerBankName = pr.partnerBankName ? pr.partnerBankName : null
                this.mainledger.partnerBankAddress = pr.partnerBankAddress ? pr.partnerBankAddress : null
                this.mainledger.partnerBankIBAN = pr.partnerBankIBAN ? pr.partnerBankIBAN : null
                this.mainledger.partnerBankSWIFT = pr.partnerBankSWIFT ? pr.partnerBankSWIFT : null
                this.selectPa = this.mainledger.partnerId ? this.partners.find(partner => (partner.id === parseInt(this.mainledger.partnerId))) : null
                this.$store.dispatch('setPartnerid', this.mainledger.partnerId)
                this.$store.dispatch('setPartnerVATID', pr.partnerVATID)
              }
            })
            .catch(err => {
              // eslint-disable-next-line
              console.log('Partner not exist', err)
              this.text = 'Error! IBAN not exist. Partner sa tim IBANom nije upisan!'
              this.color = 'red'
              this.snackbar = true
            })
          }
      },
    async createBankOrder(from1, onDate, desc1, desc2, amount, recepient, iban, call1, call2) {
      const newB = defBankOrder()
      const newBO = {...newB, ...defNewBankOrder()}
      newBO.PlatiteljIBAN = this.selectBank.bankAccountNr
      newBO.PlatiteljModel = 'HR99'
      newBO.PlatiteljPoziv = from1
      newBO.bankAccountName = this.selectBank.bankAccountName
      newBO.bankAccountNr = this.selectBank.bankAccountNr
      newBO.DatumIzvrsenja = onDate
      newBO.Opis1 = desc1
      newBO.Opis2 = desc2
      newBO.Opis3 = ''
      newBO.Iznos = amount
      newBO.Primatelj1 = recepient
      newBO.PrimateljIBAN = iban
      newBO.PrimateljModel = call1
      newBO.PrimateljPoziv = call2
      newBO.Grupa = 2
      newBO.Hitno = true
      newBO.FreeF1 = from1
      newBO.FreeF5 = 'URA'
      await BankOrderService.post(newBO)
    },
    // OIB se trazi u dva koraka: prvo nasi partneri, pa sudski registar.
    //
    // Povratna vrijednost i dalje znaci samo jedno: IMAMO LI PARTNERA U BAZI.
    // Uvoz eRacuna na njoj odlucuje hoce li pozvati addeditPartner(), pa
    // nalaz u registru ne smije vratiti true - partnera i dalje treba upisati.
    // Registar u tom slucaju samo popuni prazna polja, s kojima onda
    // addeditPartner() otvori partnera s adresom umjesto samo s OIB-om.
    //
    // Popunjavaju se SAMO prazna polja: kod uvoza eRacuna podaci dolaze od
    // dobavljaca i oni su mjerodavni.
    async findByVATID(izKlika) {
      if (this.mainledger.partnerVATID) {
          const {data} = await SudRegService.poOibu({
            CompanyId: this.$store.state.companyid,
            oib: this.mainledger.partnerVATID
          })

          if (data.izvor === 'partner') {
            this.selectPa = {}
            this.selectPa.id = data?.partner?.id ?? null
            this.selectPa.partnerName = data?.partner?.partnerName ?? null
            // partnerVATID se dodaje SAMO na korisnikov klik. Promatrac
            // selectPa tada pozove findPartner() i obrazac se napuni iz
            // sifrarnika - a to je ono sto korisnik i ocekuje kad sam trazi.
            // Kod uvoza eRacuna se ne dodaje: ondje su mjerodavni podaci
            // dobavljaca i ne smiju se prepisati nasim zapisom.
            if (izKlika) {
              this.selectPa.partnerVATID = data?.partner?.partnerVATID ?? null
              this.text = 'Partner: ' + (this.selectPa.partnerName || '(bez naziva)')
              this.color = 'green'
              this.snackbar = true
            }
            return true
          }

          if (data.izvor === 'sudreg') {
            // Firma iz registra nije nas partner, pa izbornik ne smije i dalje
            // pokazivati prethodno odabranog - inace na ekranu stoji jedan
            // partner, a u podacima drugi.
            //
            // Praznjenje ide pod zastavicom punjenjeRacuna, koju promatrac
            // selectPa vec postuje: bez nje bi promatrac na null obrisao sve
            // podatke o partneru, ukljucujuci i OIB koji je upravo upisan.
            let popunjeno = []
            this.punjenjeRacuna = true
            try {
              this.selectPa = null
              this.mainledger.partnerId = null
              // Na korisnikov klik registar smije prepisati; kod uvoza eRacuna
              // samo popunjava praznine.
              popunjeno = popuniIzRegistra(this.mainledger, data.partner, !!izKlika)
            } finally {
              await this.$nextTick()
              this.punjenjeRacuna = false
            }
            if (popunjeno.length) {
              this.text = 'Iz sudskog registra: ' + opisRegistra(data.partner)
              this.color = data.partner.sudreg && data.partner.sudreg.aktivan === false ? 'orange' : 'blue'
              this.snackbar = true
              this.timeout = 6000
            }
            return false
          }

          return false

        // this.mainQuery = {}
        // this.mainQuery.CompanyId = this.$store.state.companyid
        // this.mainQuery.partnerVATID = this.mainledger.partnerVATID
        // const {data} = await PartnerService.check(this.mainQuery)
        // const id = data && data.partner && data.partner.id ? data.partner.id : null
        // if (id) {
        //   this.selectPa =  this.partners.find(partner => (partner.id === parseInt(id)))
        //   await this.findPartner(id)
        //   this.text = 'OK!'
        //   this.color = 'green'
        //   this.snackbar = true
        //   return true
        // }
        // if (!id) {
        //   this.text = 'Error! Partner with this VATid not exist! Partner sa tim OIBom ne postoji!'
        //   this.color = 'red'
        //   this.snackbar = true
        //   return false
        // }
      }
    },
    async showPdfFunc() {
      if (this.mainledger.MLFree5) {
        const showFile ={
          showFile: this.mainledger.MLFree5
        }
        await MainLedgerService.showPdf(showFile)
        .then(res => {
          const data = res.data
          var byteCharacters = atob(data);
          var byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          var byteArray = new Uint8Array(byteNumbers);
          var blob = new Blob([byteArray], { type: "application/pdf" });

          //FileSaver.saveAs(blob, "invoice.pdf")

          // // const zoveSe = this.mainledger.MLFree2 ? this.mainledger.MLFree2 : 'Book'
          //const header = res.headers
          //const fileType = header['content-type']
          //const file = new Blob([data], {type: fileType})
          // eslint-disable-next-line
          //console.log(' have file ', file)
          const fileurl = window.URL.createObjectURL(blob)
          window.open(fileurl)
          //FileSaver.saveAs(file, 'invoice.pdf');
        }).catch(error => {
          this.text = 'Error ' + error
          this.color = 'red'
          this.snackbar = true
        })
      } else {
        alert('Sorry, document is not defined! Can not open.')
      }
    },
    async register () {
      try {
         this.localError = false
          const haveYear = dayjs(this.mainledger.BookingDate).year()
          if (haveYear !== this.$store.state.businessYear) {
            this.text = 'Greška!! Datum temeljnice je u krivoj poslovnoj godini !!'
            this.color = 'red'
            this.snackbar = true
            this.timeout = 3000
            return
          }

         if (!this.mainledger.InvoiceAmount || this.mainledger.InvoiceAmount === 0){
          this.mainledger.paidClosed = false
          this.mainledger.paidDate = null
          this.mainledger.paidHome = 0
          this.mainledger.paidFore = 0
          this.text = 'Greska! Iznos je 0!! Error!! Invoice Amount is zero '
          this.color = 'red'
          this.snackbar = true
          return
         }

         if (this.selectPa.partnerVATID) {
            const locPartner = (await PartnerService.show(this.selectPa.partnerVATID)).data.partner
            this.mainledger.partnerId = locPartner.id
            this.mainledger.partnerName = locPartner.partnerName
            this.mainledger.partnerNameShort = locPartner.partnerNameShort
            this.mainledger.partnerNameDatabase = locPartner.partnerNameDatabase
            this.mainledger.partnerBuildingNameNumber = locPartner.partnerBuildingNameNumber
            this.mainledger.partnerStreet = locPartner.partnerStreet
            this.mainledger.partnerCity = locPartner.partnerCity
            this.mainledger.partnerPostcode = locPartner.partnerPostcode
            this.mainledger.partnerCountyRegion = locPartner.partnerCountyRegion
            this.mainledger.partnerState = locPartner.partnerState
            this.mainledger.partnerVATID = locPartner.partnerVATID
            this.mainledger.partneremail = locPartner.partneremail
            this.mainledger.partnerPhones = locPartner.partnerPhones
            this.mainledger.partnerBankName = locPartner.partnerBankName
            this.mainledger.partnerBankAddress = locPartner.partnerBankAddress
            this.mainledger.partnerBankIBAN = locPartner.partnerBankIBAN
            this.mainledger.partnerBankSWIFT = locPartner.partnerBankSWIFT
        }

        if (!this.mainledger.partnerName || this.mainledger.partnerName.trim().length === 0){
          this.text = 'Greska! Nema naziva partnera!! Error!! Partner name is empty!! '
          this.color = 'red'
          this.snackbar = true
          return
        }
        if (!this.mainledger.partnerVATID || (typeof this.mainledger.partnerVATID === 'string' && this.mainledger.partnerVATID.trim().length === 0)){
          this.text = 'Greska! Nema OIBa partnera!! Error!! Partner VATid is empty!! '
          this.color = 'red'
          this.snackbar = true
          return
        }
        if (!this.mainledger.MLBool1) {
          const partVatLeght = typeof this.mainledger.partnerVATID === 'string' ? this.mainledger.partnerVATID.trim().length : this.mainledger.partnerVATID.toString().length()
          if (partVatLeght !== 11) {
            this.text = this.lang.PartnerErrorVAT3
            this.color = 'red'
            this.snackbar = true
            this.timeout = 3000
            return
          }
        }
        
        await this.checkNotNull()
        if (!this.admin) {
          if (this.$store.state.editItem === 0 && this.mainledger.BookID !== 0) {   
            this.text = 'Greska! Dokument je vec snimljen!! '
            this.color = 'red'
            this.snackbar = true
            return
          }
        }
        this.mainQuery = {...defMainQuery()}
        
        // when enter NEW invoice check if already exist with these number
        // if (this.$store.state.editItem === 0 && this.mainledger.MLType === 1) {
        //   const findWhat = {}
        //   findWhat.CompanyId  = this.$store.state.companyid ? this.$store.state.companyid : 1
        //   findWhat.BusinessYear =  this.$store.state.businessYear ? this.$store.state.businessYear : 2021
        //   findWhat.MLType = 1
        //   findWhat.InvoiceNumber = this.mainledger.InvoiceNumber ? this.mainledger.InvoiceNumber : 9999999999
        //   findWhat.partnerVATID = this.mainledger.partnerVATID ? this.mainledger.partnerVATID : 9999999999
        //   const res = await MainLedgerService.find(findWhat)
        //   if (res.data && res.data.mainLedger && res.data.mainLedger.length > 0) {
        //     this.text = 'Greska! URA sa tim brojem već postoji u knjizi URA. Error! Invoice with this number already exist in books! '
        //     this.color = 'red'
        //     this.snackbar = true
        //     return
        //   }
        // }

        if (this.bookSubTypeSelected && this.bookSubTypeSelected.value) {
            this.mainledger.BookSubTypeID = parseInt(this.bookSubTypeSelected.value)
            this.mainledger.BookSubName = this.bookSubTypeSelected.text


        } else {
          this.mainledger.BookSubTypeID = null
          this.mainledger.BookSubName = null
        }

        // if (this.$store.state.editItem === 0) {

        //   if (this.$store.state.bookTypeSelected && this.$store.state.bookTypeSelected.value) {

        //     if (this.mainledger.BookID === 0) {
        //       this.mainledger.BookID = (await MainLedgerService.choose(this.mainQuery)).data.docNumber
        //     }

        //     this.mainledger.documentIdGeneral = this.$store.state.companyName + '-' + this.$store.state.businessYear + '-' + this.$store.state.documentActiv + '-' + this.mainledger.BookID 

        //     await MainLedgerService.post(this.mainledger)
        //     .then(res => {
        //       this.savedML = res.data.mainledger ? res.data.mainledger : {}
        //       this.locBookID = parseInt(this.savedML.BookID)
        //       if (this.mainledger.MLType === 1) {
        //         this.createBankOrder((this.mainledger.BookID ? parseInt(this.mainledger.BookID) : 0), this.mainledger.InvoicePaymentDeadlineDate, this.mainledger.PayDesc, '', this.mainledger.InvoiceAmount, this.mainledger.partnerName, this.mainledger.partnerBankIBAN, this.mainledger.Pay1, this.mainledger.Pay2)
        //       }
        //       if (this.$store.state.language === 'EN') {
        //         this.text = 'New mainledger doc has been saved.'
        //         this.color = 'green'
        //         this.snackbar = true
        //       }
        //       if (this.$store.state.language === 'HR') {
        //         this.text = this.$store.state.documentSide === 1 ? 'Nova ura je snimljena u bazu.' : 'Nova ira je snimljena u bazu.'
        //         this.color = 'green'
        //         this.snackbar = true
        //       }
        //     })
        //     .catch(err => {
        //       this.error = err.data
        //       this.text = 'Error1! Cannot save document to database. ' + err
        //       this.color = 'red'
        //       this.snackbar = true
        //     })
        //   } else {
        //     this.text = 'Greska! Nije odabrana vrsta knjige!!'
        //     this.color = 'red'
        //     this.snackbar = true
        //   }
        // }        
        if (this.$store.state.editItem === 1) {
          if (this.bookTypeSelected.value) {
            this.mainledger.BookTypeID = parseInt(this.bookTypeSelected.value)
            this.mainledger.BookName = this.bookTypeSelected.text
          }
          await this.$store.dispatch('setMainLedgerActiv', this.mainledger ? this.mainledger : {})

          await MainLedgerService.put(this.mainledger)
         
          // update items
          this.mldetails = (await MainLedgerDetailService.index(this.mainledger.id)).data.mainledgerDetails
          const updateHead = defMainLedgerDetailFill()
          const updatedItems = []
          if (this.mldetails) {
          
            this.mldetails.map(detail => {
              const newItem = {...detail, ...updateHead}
              updatedItems.push(newItem)
            })
          }
          if (updatedItems && updatedItems.length >0) {
            await MainLedgerDetailService.saveitems(updatedItems)
          }

          this.$router.push({
            name: 'mainledger'
          })
        }

      } catch (error) {
        this.error = error.data
        this.text = 'Error2! Cannot save document to database. ' + error.data
        this.color = 'red'
        this.snackbar = true
      }
    },
    close () {
      this.show = false
    },
    calculateSecAmount () {
      this.mainledger.InvoiceForeginAmount = (this.mainledger.InvoiceAmount) / (this.mainledger.ExRate)
      // this.mainledger.VAT1Base = this.round((((this.mainledger.InvoiceAmount) / (1 + (this.mainledger.VAT1Per) / 100))),2)
      // this.mainledger.VAT1Amount = this.round(((this.mainledger.InvoiceAmount) - this.mainledger.VAT1Base),2)
      // this.mainledger.VAT1CanUse = this.round(((this.mainledger.InvoiceAmount) - this.mainledger.VAT1Base),2)
    },
    calculateFirstAmount () {
      if (round(this.mainledger.InvoiceAmount, 2) !== 0 && !this.showUploadERacun) {
        if (this.$store.state.editItem === 0) {
        this.mainledger.InvoiceForeginAmount = this.round(((this.mainledger.InvoiceAmount) / (this.mainledger.ExRate)),2)
        //this.mainledger.InvoiceAmount = this.round((this.mainledger.InvoiceForeginAmount * this.mainledger.ExRate),2)
          this.mainledger.VAT1Amount = round((this.mainledger.InvoiceAmount - round((this.mainledger.InvoiceAmount / 1.25) ,2)),2)
         //this.mainledger.VAT1PerCanUse = 100
          this.mainledger.VAT1CanUse = round(this.mainledger.VAT1Amount,2)
         // this.mainledger.VAT1CanTUse = 0
          this.mainledger.VAT1Base = round((this.mainledger.InvoiceAmount - this.mainledger.VAT1Amount) ,2)
          this.calculateFirstVAT()
        }
        // this.mainledger.VAT1Amount = round((this.mainledger.InvoiceAmount - round((this.mainledger.InvoiceAmount / 1.25) ,2)),2)
        // this.mainledger.VAT1Base = this.round((((this.mainledger.InvoiceAmount) / (1 + (this.mainledger.VAT1Per) / 100))),2)
        // this.mainledger.VAT1CanUse = this.round(((this.mainledger.InvoiceAmount) - this.mainledger.VAT1Base),2)
      }
    },
    calculateFirstVAT () {
      if (round(this.mainledger.VAT1PerCanUse,2) !== 100 && !this.showUploadERacun) {
        this.mainledger.VAT1CanUse = round((this.mainledger.VAT1Amount * (this.mainledger.VAT1PerCanUse / 100)) ,2)
        this.mainledger.VAT1CanTUse = this.mainledger.VAT1Amount - this.mainledger.VAT1CanUse
        this.mainledger.VAT1Base = round(((this.mainledger.VAT1CanUse + this.mainledger.VAT1CanTUse) / ( this.mainledger.VAT1Per / 100)),2)
        this.calculateVATAmount()
      }
      if (round(this.mainledger.VAT1PerCanUse,2) === 100 && !this.showUploadERacun) {
        this.mainledger.VAT1CanUse = round(this.mainledger.VAT1Amount,2)
        this.mainledger.VAT1CanTUse = 0
        this.mainledger.VAT1Base = round((this.mainledger.InvoiceAmount - this.mainledger.VAT1Amount) ,2)
        this.calculateVATAmount()
      }
      
    },
    calculateSecondVAT () {
      if (!this.showUploadERacun) {
        this.mainledger.VAT2CanUse = round((this.mainledger.VAT2Amount * (this.mainledger.VAT2PerCanUse / 100)), 2)
        this.mainledger.VAT2CanTUse = this.mainledger.VAT2Amount - this.mainledger.VAT2CanUse
        this.mainledger.VAT2Base = round(((this.mainledger.VAT2CanUse + this.mainledger.VAT2CanTUse) / ( this.mainledger.VAT2Per / 100)), 2)
        this.calculateVATAmount()
      }
    },
    calculateThirdVAT () {
      if (!this.showUploadERacun) {
        this.mainledger.VAT3CanUse = round((this.mainledger.VAT3Amount * ((this.mainledger.VAT3PerCanUse) / 100)), 2)
        this.mainledger.VAT3CanTUse = this.mainledger.VAT3Amount - this.mainledger.VAT3CanUse
        this.mainledger.VAT3Base = round(((this.mainledger.VAT3CanUse + this.mainledger.VAT3CanTUse) / (this.mainledger.VAT3Per / 100)), 2)
        this.calculateVATAmount()
      }
    },
    beforeRegister() {
      this.checkNotNull()
      const haveDiff = round((this.mainledger.InvoiceAmount - this.mainledger.VAT1Base - this.mainledger.VAT1Amount - this.mainledger.VAT2Base - this.mainledger.VAT2Amount - this.mainledger.VAT3Base - this.mainledger.VAT3Amount - this.mainledger.VAT4Base), 2)
      if (haveDiff !== 0) {
        if (confirm('Razlika kod razrade računa u iznosu = ' + haveDiff + '.Da li ste sigurni da želite proknjižiti taj račun?')) {
          this.register()
        }
      } else {
        this.register()
      }
    },
    calculateVATAmount () {
      // Kroz parseNum, a ne izravnim zbrajanjem. Na novom dokumentu polja PDV-a
      // jos nisu popunjena, pa su "undefined" - a "undefined + broj" je NaN.
      // Taj NaN je zatim isao i u "AmountNetto" i, sto je gore, u zapis koji se
      // sprema u bazu, ne samo u prikaz.
      const pdv1 = parseNum(this.mainledger.VAT1Amount)
      const pdv2 = parseNum(this.mainledger.VAT2Amount)
      const pdv3 = parseNum(this.mainledger.VAT3Amount)
      const iznos = parseNum(this.mainledger.InvoiceAmount)
      const osnovica4 = parseNum(this.mainledger.VAT4Base)
      this.mainledger.AmountVAT = round(pdv1 + pdv2 + pdv3, 2)
      this.mainledger.AmountNetto = round(iznos - this.mainledger.AmountVAT - osnovica4, 2)
    },
    focusBookingD() {
      this.$refs.bookingd.focus()
    },
    focusINNR() {
      // 👇 call custom "focus" method
      this.$refs.innr.focus()
    },
    // OIB se ponegdje upisuje s prefiksom HR ili s razmacima. Strani PDV broj
    // (IE6364992H, ESB93183366) nosi slova kao dio broja, pa se ona zadrzavaju -
    // odbacuje se samo HR ispred hrvatskog jedanaesteroznamenkastog OIB-a.
    istiOIB (prvi, drugi) {
      const cisti = (v) => {
        let t = String(v === null || v === undefined ? '' : v).toUpperCase().replace(/[^A-Z0-9]/g, '')
        if (t.indexOf('HR') === 0 && /^\d{11}$/.test(t.substring(2))) { t = t.substring(2) }
        return t
      }
      const a = cisti(prvi)
      const b = cisti(drugi)
      return a.length > 0 && a === b
    },
    // Partner kojeg nema u lokalnoj listi - sastavi se iz podataka na racunu,
    // da izbornik pokaze ime i da se nista ne izgubi kod spremanja.
    partnerSRacuna () {
      const ml = this.mainledger
      if (!ml.partnerName && !ml.partnerVATID) { return null }
      return {
        id: ml.partnerId ? parseInt(ml.partnerId) : null,
        partnerName: ml.partnerName ? ml.partnerName : ml.partnerVATID,
        partnerNameShort: ml.partnerNameShort,
        partnerNameDatabase: ml.partnerNameDatabase,
        partnerVATID: ml.partnerVATID,
        partnerStreet: ml.partnerStreet,
        partnerBuildingNameNumber: ml.partnerBuildingNameNumber,
        partnerCity: ml.partnerCity,
        partnerPostcode: ml.partnerPostcode,
        partnerBankIBAN: ml.partnerBankIBAN,
        partneremail: ml.partneremail,
        izvanListe: true
      }
    },
    async findPartner () {
       console.log('trazim partnera normalno ', this.selectPa )
      if (this.selectPa && this.selectPa.partnerVATID) {
        const locPartner = (await PartnerService.show(this.selectPa.partnerVATID)).data.partner
        this.mainledger.partnerId = locPartner.id
        this.mainledger.partnerName = locPartner.partnerName
        this.mainledger.partnerNameShort = locPartner.partnerNameShort
        this.mainledger.partnerNameDatabase = locPartner.partnerNameDatabase
        this.mainledger.partnerBuildingNameNumber = locPartner.partnerBuildingNameNumber
        this.mainledger.partnerStreet = locPartner.partnerStreet
        this.mainledger.partnerCity = locPartner.partnerCity
        this.mainledger.partnerPostcode = locPartner.partnerPostcode
        this.mainledger.partnerCountyRegion = locPartner.partnerCountyRegion
        this.mainledger.partnerState = locPartner.partnerState
        this.mainledger.partnerVATID = locPartner.partnerVATID
        this.mainledger.partneremail = locPartner.partneremail
        this.mainledger.partnerPhones = locPartner.partnerPhones
        this.mainledger.partnerBankName = locPartner.partnerBankName
        this.mainledger.partnerBankAddress = locPartner.partnerBankAddress
        this.mainledger.partnerBankIBAN = locPartner.partnerBankIBAN
        this.mainledger.partnerBankSWIFT = locPartner.partnerBankSWIFT
        this.focusINNR()
      }
    },
    checkNotNull() {
      console.log('check Not null')
      this.mainledger.InvoiceAmount = this.mainledger.InvoiceAmount ? (this.mainledger.InvoiceAmount) : 0
      this.mainledger.InvoiceForeginAmount = this.mainledger.InvoiceForeginAmount ? (this.mainledger.InvoiceForeginAmount) : 0

      //this.mainledger.VAT1Per = this.mainledger.VAT1Per ? (this.mainledger.VAT1Per) : 25
      if ( this.mainledger.VAT1Base) {
        this.mainledger.VAT1Base = parseNum(this.mainledger.VAT1Base)
      }
      if (this.mainledger.VAT1Amount) {
        this.mainledger.VAT1Amount =  parseNum(this.mainledger.VAT1Amount)
      }
      if (this.mainledger.VAT1PerCanUse ) {
        this.mainledger.VAT1PerCanUse = parseNum(this.mainledger.VAT1PerCanUse)
      }
      if (this.mainledger.VAT1CanUse) {
        this.mainledger.VAT1CanUse = parseNum(this.mainledger.VAT1CanUse)
      }
      if (this.mainledger.VAT1CanTUse ) {
        this.mainledger.VAT1CanTUse = parseNum(this.mainledger.VAT1CanTUse)
      }
      //this.mainledger.VAT2Per = this.mainledger.VAT2Per ? parseNum(this.mainledger.VAT2Per) : 13
      if (this.mainledger.VAT2Base) {
        this.mainledger.VAT2Base =  parseNum(this.mainledger.VAT2Base)
      }
      if (this.mainledger.VAT2Amount) {
        this.mainledger.VAT2Amount = parseNum(this.mainledger.VAT2Amount) 
      }
      if (this.mainledger.VAT2PerCanUse) {
        this.mainledger.VAT2PerCanUse = parseNum(this.mainledger.VAT2PerCanUse)
      }
      if (this.mainledger.VAT2CanUse) {
        this.mainledger.VAT2CanUse = parseNum(this.mainledger.VAT2CanUse)
      }
      if (this.mainledger.VAT2CanTUse) {
        this.mainledger.VAT2CanTUse = parseNum(this.mainledger.VAT2CanTUse)
      }
      //this.mainledger.VAT3Per = this.mainledger.VAT3Per ? parseNum(this.mainledger.VAT3Per) : 5
      if (this.mainledger.VAT3Base) {
        this.mainledger.VAT3Base =  parseNum(this.mainledger.VAT3Base)
      }
      if (this.mainledger.VAT3Amount) {
        this.mainledger.VAT3Amount = parseNum(this.mainledger.VAT3Amount)
      }
      if (this.mainledger.VAT3PerCanUse) {
        this.mainledger.VAT3PerCanUse = parseNum(this.mainledger.VAT3PerCanUse)
      }
      if (this.mainledger.VAT3CanUse) {
        this.mainledger.VAT3CanUse =  parseNum(this.mainledger.VAT3CanUse)
      }
      if (this.mainledger.VAT3CanTUse) {
        this.mainledger.VAT3CanTUse = parseNum(this.mainledger.VAT3CanTUse)
      }
      if (this.mainledger.VAT4Per) {
        this.mainledger.VAT4Per = parseNum(this.mainledger.VAT4Per)
      }


      this.mainledger.VAT4Base = this.mainledger.VAT4Base ? (this.mainledger.VAT4Base) : 0
      this.mainledger.VAT4Amount = this.mainledger.VAT4Amount ? (this.mainledger.VAT4Amount) : 0
      this.mainledger.VAT4PerCanUse = this.mainledger.VAT4PerCanUse ? (this.mainledger.VAT4PerCanUse) : 0
      this.mainledger.VAT4CanUse = this.mainledger.VAT4CanUse ? (this.mainledger.VAT4CanUse) : 0
      this.mainledger.VAT4CanTUse = this.mainledger.VAT4CanTUse ? (this.mainledger.VAT4CanTUse) : 0
      this.mainledger.VAT5Per = this.mainledger.VAT5Per ? (this.mainledger.VAT5Per) : 0
      this.mainledger.VAT5Base = this.mainledger.VAT5Base? (this.mainledger.VAT5Base) : 0
      this.mainledger.VAT5Amount = this.mainledger.VAT5Amount ? (this.mainledger.VAT5Amount) : 0
      this.mainledger.VAT5PerCanUse = this.mainledger.VAT5PerCanUse ? (this.mainledger.VAT5PerCanUse) : 0
      this.mainledger.VAT5CanUse = this.mainledger.VAT5CanUse  ? (this.mainledger.VAT5CanUse) : 0
      this.mainledger.VAT5CanTUse = this.mainledger.VAT5CanTUse ? (this.mainledger.VAT5CanTUse) : 0

      this.mainledger.AmountNetto = this.mainledger.AmountNetto  ? (this.mainledger.AmountNetto) : 0
      this.mainledger.AmountVAT = this.mainledger.AmountVAT ? (this.mainledger.AmountVAT) : 0
      this.mainledger.AmountBrutto = this.mainledger.AmountBrutto ? (this.mainledger.AmountBrutto) : 0
      this.mainledger.AmountPayInAdvance = this.mainledger.AmountPayInAdvance ? (this.mainledger.AmountPayInAdvance) : 0
      this.mainledger.AmountToPay = this.mainledger.AmountToPay ? (this.mainledger.AmountToPay) : 0
      this.mainledger.AmountNettoForeign = this.mainledger.AmountNettoForeign? (this.mainledger.AmountNettoForeign) : 0
      this.mainledger.AmountVATForeign = this.mainledger.AmountVATForeign ? (this.mainledger.AmountVATForeign) : 0
      this.mainledger.AmountBruttoForeign = this.mainledger.AmountBruttoForeign ? (this.mainledger.AmountBruttoForeign) : 0
      this.mainledger.AmountPayInAdvanceForeign = this.mainledger.AmountPayInAdvanceForeign ? (this.mainledger.AmountPayInAdvanceForeign): 0
      this.mainledger.AmountToPayForeign = this.mainledger.AmountToPayForeign ? (this.mainledger.AmountToPayForeign) : 0
      this.mainledger.Debit = this.mainledger.Debit? (this.mainledger.Debit) : 0,
      this.mainledger.Credit = this.mainledger.Credit ? (this.mainledger.Credit) : 0
      this.mainledger.DebitForegin = this.mainledger.DebitForegin ? (this.mainledger.DebitForegin) : 0
      this.mainledger.CreditForegin = this.mainledger.CreditForegin ? (this.mainledger.CreditForegin) : 0
      this.mainledger.DebitTotal = this.mainledger.DebitTotal ? (this.mainledger.DebitTotal) : 0
      this.mainledger.CreditTotal = this.mainledger.CreditTotal ? (this.mainledger.CreditTotal): 0
      this.mainledger.DebitForeginTotal = this.mainledger.DebitForeginTotal ? (this.mainledger.DebitForeginTotal) : 0
      this.mainledger.CreditForeginTotal = this.mainledger.CreditForeginTotal? (this.mainledger.CreditForeginTotal) : 0

      this.mainledger.WareHouseId = this.mainledger.WareHouseId ? this.mainledger.WareHouseId : 0
      this.mainledger.WareHouseEntry = this.mainledger.WareHouseEntry ? this.mainledger.WareHouseEntry : 0
      this.mainledger.WareHouseEntryAmount = this.mainledger.WareHouseEntryAmount? this.mainledger.WareHouseEntryAmount : 0
    },
    doParse() {
      this.mainledger.InvoiceAmount = this.mainledger.InvoiceAmount ? parseNum(this.mainledger.InvoiceAmount) : 0
      this.mainledger.InvoiceForeginAmount = this.mainledger.InvoiceForeginAmount ? parseNum(this.mainledger.InvoiceForeginAmount) : 0
      //this.mainledger.VAT1Per = this.mainledger.VAT1Per ? parseNum(this.mainledger.VAT1Per) : 25
      if ( this.mainledger.VAT1Base) {
        this.mainledger.VAT1Base = parseNum(this.mainledger.VAT1Base)
      }
      if (this.mainledger.VAT1Amount) {
        this.mainledger.VAT1Amount =  parseNum(this.mainledger.VAT1Amount)
      }
      if (this.mainledger.VAT1PerCanUse ) {
        this.mainledger.VAT1PerCanUse = parseNum(this.mainledger.VAT1PerCanUse)
      }
      if (this.mainledger.VAT1CanUse) {
        this.mainledger.VAT1CanUse = parseNum(this.mainledger.VAT1CanUse)
      }
      if (this.mainledger.VAT1CanTUse ) {
        this.mainledger.VAT1CanTUse = parseNum(this.mainledger.VAT1CanTUse)
      }
      //this.mainledger.VAT2Per = this.mainledger.VAT2Per ? parseNum(this.mainledger.VAT2Per) : 13
      if (this.mainledger.VAT2Base) {
        this.mainledger.VAT2Base =  parseNum(this.mainledger.VAT2Base)
      }
      if (this.mainledger.VAT2Amount) {
        this.mainledger.VAT2Amount = parseNum(this.mainledger.VAT2Amount) 
      }
      if (this.mainledger.VAT2PerCanUse) {
        this.mainledger.VAT2PerCanUse = parseNum(this.mainledger.VAT2PerCanUse)
      }
      if (this.mainledger.VAT2CanUse) {
        this.mainledger.VAT2CanUse = parseNum(this.mainledger.VAT2CanUse)
      }
      if (this.mainledger.VAT2CanTUse) {
        this.mainledger.VAT2CanTUse = parseNum(this.mainledger.VAT2CanTUse)
      }
      //this.mainledger.VAT3Per = this.mainledger.VAT3Per ? parseNum(this.mainledger.VAT3Per) : 5
      if (this.mainledger.VAT3Base) {
        this.mainledger.VAT3Base =  parseNum(this.mainledger.VAT3Base)
      }
      if (this.mainledger.VAT3Amount) {
        this.mainledger.VAT3Amount = parseNum(this.mainledger.VAT3Amount)
      }
      if (this.mainledger.VAT3PerCanUse) {
        this.mainledger.VAT3PerCanUse = parseNum(this.mainledger.VAT3PerCanUse)
      }
      if (this.mainledger.VAT3CanUse) {
        this.mainledger.VAT3CanUse =  parseNum(this.mainledger.VAT3CanUse)
      }
      if (this.mainledger.VAT3CanTUse) {
        this.mainledger.VAT3CanTUse = parseNum(this.mainledger.VAT3CanTUse)
      }
      if (this.mainledger.VAT4Per) {
        this.mainledger.VAT4Per = parseNum(this.mainledger.VAT4Per)
      }

      this.mainledger.VAT4Base = this.mainledger.VAT4Base ? parseNum(this.mainledger.VAT4Base) : 0
      this.mainledger.VAT4Amount = this.mainledger.VAT4Amount ? parseNum(this.mainledger.VAT4Amount) : 0
      this.mainledger.VAT4PerCanUse = this.mainledger.VAT4PerCanUse ? parseNum(this.mainledger.VAT4PerCanUse) : 0
      this.mainledger.VAT4CanUse = this.mainledger.VAT4CanUse ? parseNum(this.mainledger.VAT4CanUse) : 0
      this.mainledger.VAT4CanTUse = this.mainledger.VAT4CanTUse ? parseNum(this.mainledger.VAT4CanTUse) : 0
      this.mainledger.VAT5Per = this.mainledger.VAT5Per ? parseNum(this.mainledger.VAT5Per) : 0
      this.mainledger.VAT5Base = this.mainledger.VAT5Base ? parseNum(this.mainledger.VAT5Base) : 0
      this.mainledger.VAT5Amount = this.mainledger.VAT5Amount ? parseNum(this.mainledger.VAT5Amount) : 0
      this.mainledger.VAT5PerCanUse = this.mainledger.VAT5PerCanUse ? parseNum(this.mainledger.VAT5PerCanUse) : 0
      this.mainledger.VAT5CanUse = this.mainledger.VAT5CanUse ? parseNum(this.mainledger.VAT5CanUse) : 0
      this.mainledger.VAT5CanTUse = this.mainledger.VAT5CanTUse ? parseNum(this.mainledger.VAT5CanTUse) : 0
 
      this.mainledger.AmountNetto = this.mainledger.AmountNetto ? parseNum(this.mainledger.AmountNetto) : 0
      this.mainledger.AmountVAT = this.mainledger.AmountVAT ? parseNum(this.mainledger.AmountVAT) : 0
      this.mainledger.AmountBrutto = this.mainledger.AmountBrutto ? parseNum(this.mainledger.AmountBrutto) : 0
      this.mainledger.AmountPayInAdvance = this.mainledger.AmountPayInAdvance ? parseNum(this.mainledger.AmountPayInAdvance) : 0
      this.mainledger.AmountToPay = this.mainledger.AmountToPay ? parseNum(this.mainledger.AmountToPay) : 0
      this.mainledger.AmountNettoForeign = this.mainledger.AmountNettoForeign ? parseNum(this.mainledger.AmountNettoForeign) : 0
      this.mainledger.AmountVATForeign = this.mainledger.AmountVATForeign ? parseNum(this.mainledger.AmountVATForeign) : 0
      this.mainledger.AmountBruttoForeign = this.mainledger.AmountBruttoForeign ? parseNum(this.mainledger.AmountBruttoForeign) : 0
      this.mainledger.AmountPayInAdvanceForeign = this.mainledger.AmountPayInAdvanceForeign ? parseNum(this.mainledger.AmountPayInAdvanceForeign): 0
      this.mainledger.AmountToPayForeign = this.mainledger.AmountToPayForeign ? parseNum(this.mainledger.AmountToPayForeign) : 0
      this.mainledger.Debit = this.mainledger.Debit ? parseNum(this.mainledger.Debit) : 0
      this.mainledger.Credit = this.mainledger.Credit ? parseNum(this.mainledger.Credit) : 0
      this.mainledger.DebitForegin = this.mainledger.DebitForegin ? parseNum(this.mainledger.DebitForegin) : 0
      this.mainledger.CreditForegin = this.mainledger.CreditForegin ? parseNum(this.mainledger.CreditForegin) : 0
      this.mainledger.DebitTotal = this.mainledger.DebitTotal ? parseNum(this.mainledger.DebitTotal) : 0
      this.mainledger.CreditTotal = this.mainledger.CreditTotal ? parseNum(this.mainledger.CreditTotal): 0
      this.mainledger.DebitForeginTotal = this.mainledger.DebitForeginTotal ? parseNum(this.mainledger.DebitForeginTotal) : 0
      this.mainledger.CreditForeginTotal = this.mainledger.CreditForeginTotal ? parseNum(this.mainledger.CreditForeginTotal) : 0
      this.mainledger.WareHouseId = this.mainledger.WareHouseId ? this.mainledger.WareHouseId : 0
      this.mainledger.WareHouseEntry = this.mainledger.WareHouseEntry ? this.mainledger.WareHouseEntry : 0
      this.mainledger.WareHouseEntryAmount = this.mainledger.WareHouseEntryAmount ? this.mainledger.WareHouseEntryAmount : 0
      this.mainledger.Goods = this.mainledger.Goods ? parseNum(this.mainledger.Goods) : 0
      this.mainledger.Services = this.mainledger.Services ? parseNum(this.mainledger.Services) : 0
      this.mainledger.GoodsEU = this.mainledger.GoodsEU ? parseNum(this.mainledger.GoodsEU) : 0
      this.mainledger.ServicesEU = this.mainledger.ServicesEU ? parseNum(this.mainledger.ServicesEU) : 0
    },
    async mainledgerlist () {
      try {
        await this.$router.push({
          name: 'mainledger'
        })
      } catch (err) {
        this.error = err.data
        // eslint-disable-next-line
        console.log(err)
      }
    },
    mainledgerupload() {
      this.showUpload = !this.showUpload
    },
    async mainledgeragain () {
      try {
        this.$store.dispatch('setpathAgain', 'mainledgercreate')
        await this.$router.push({
          name: 'mainledger'
        })
        // Object.assign(this.$data, this.$options.data.call(this))
        // location.reload()
        // this.$forceUpdate()
      } catch (err) {
        this.error = err.data
        // eslint-disable-next-line
        console.log(err)
      }
    },
    clearPartner() {
      this.selectPa = null
      this.mainledger.partnerId = null
      this.mainledger.partnerName = null
      this.mainledger.partnerNameShort = null
      this.mainledger.partnerNameDatabase = null
      this.mainledger.partnerBuildingNameNumber = null
      this.mainledger.partnerStreet = null
      this.mainledger.partnerCity = null
      this.mainledger.partnerPostcode = null
      this.mainledger.partnerCountyRegion = null
      this.mainledger.partnerState = null
      this.mainledger.partnerVATID = null
      this.mainledger.partneremail = null
      this.mainledger.partnerPhones = null
      this.mainledger.partnerBankName = null
      this.mainledger.partnerBankAddress = null
      this.mainledger.partnerBankIBAN = null
      this.mainledger.partnerBankSWIFT = null
      this.mainledger.partnerContactTime = null
      this.mainledger.partnerSecretaryTitle = null
      this.mainledger.partnerSecretaryFirst = null
      this.mainledger.partnerSecretaryLast = null
      this.mainledger.partnerSecretaryEmail = null
      this.mainledger.partnerSecretaryPhone = null
      this.mainledger.partnerSecretaryContactOption = null
      this.mainledger.privatePerson = false
    },
    round (value, decimals) {
      return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals)
    },
    async addeditPartner () {
      console.log('dodajem Novog partnera', this.mainledger.partnerVATID)
        this.mainledger.partnerVATID = this.mainledger.partnerVATID && typeof this.mainledger.partnerVATID === 'string' ? this.mainledger.partnerVATID.trim() : this.mainledger.partnerVATID.toString().trim()
        this.mainledger.partnerName = this.mainledger.partnerName ? this.mainledger.partnerName.trim() : null
        if (!this.mainledger.partnerName || this.mainledger.partnerName.length === 0) {
          this.text = 'Partner nema ime! Partner name is not defined!'
          this.color = 'red'
          this.snackbar = true
          return
        }
        if (!this.mainledger.partnerVATID || this.mainledger.partnerVATID.trim().length === 0) {
          this.text = 'Partner nema OIB! Partner VAT ID is not defined!'
          this.color = 'red'
          this.snackbar = true
          return
        }
        // if (!this.mainledger.partneremail || this.mainledger.partneremail.trim().length === 0) {
        //   this.text = 'Partner nema email! Partner email is not defined!'
        //   this.color = 'red'
        //   this.snackbar = true
        //   return
        // }
        const addeditPartner = {...defNewpartner()}
        addeditPartner.CompanyId = this.mainledger.CompanyId ? this.mainledger.CompanyId : ''
        addeditPartner.CompanyNameDatabase = this.mainledger.CompanyNameDatabase
        addeditPartner.BusinessYear = this.mainledger.BusinessYear
        addeditPartner.UserId = this.mainledger.UserId
        addeditPartner.email = this.mainledger.email
        addeditPartner.First = this.mainledger.First
        addeditPartner.Last = this.mainledger.Last
        addeditPartner.partnerName = this.mainledger.partnerName
        addeditPartner.partnerNameShort = this.mainledger.partnerName.replace(/[\W_]/g, '')
        addeditPartner.partnerNameDatabase = this.mainledger.partnerName.replace(/[\W_]/g, '')
        addeditPartner.partnerBuildingNameNumber = this.mainledger.partnerBuildingNameNumber
        addeditPartner.partnerStreet = this.mainledger.partnerStreet
        addeditPartner.partnerCity = this.mainledger.partnerCity
        addeditPartner.partnerPostcode = this.mainledger.partnerPostcode
        addeditPartner.partnerCountyRegion = this.mainledger.partnerCountyRegion
        addeditPartner.partnerState = this.mainledger.partnerState
        addeditPartner.partnerVATID = this.mainledger.partnerVATID
        addeditPartner.partneremail = this.mainledger?.partneremail ?? "no_email@noemail.com"
        addeditPartner.partnerPhones = this.mainledger.partnerPhones
        addeditPartner.partnerBankName = this.mainledger.partnerBankName
        addeditPartner.partnerBankAddress = this.mainledger.partnerBankAddress
        addeditPartner.partnerBankIBAN = this.mainledger.partnerBankIBAN
        addeditPartner.partnerBankSWIFT = this.mainledger.partnerBankSWIFT
        addeditPartner.partnerContactTime = this.mainledger.partnerContactTime
        addeditPartner.partnerSecretaryTitle = this.mainledger.partnerSecretaryTitle
        addeditPartner.partnerSecretaryFirst = this.mainledger.partnerSecretaryFirst
        addeditPartner.partnerSecretaryLast = this.mainledger.partnerSecretaryLast
        addeditPartner.partnerSecretaryEmail = this.mainledger.partnerSecretaryEmail
        addeditPartner.partnerSecretaryPhone = this.mainledger.partnerSecretaryPhone
        addeditPartner.partnerSecretaryContactOption = this.mainledger.partnerSecretaryContactOption
        addeditPartner.privatePerson = this.mainledger?.privatePerson ?? false
        this.saving = true
        this.mainQuery2 = {}
        this.mainQuery2.CompanyId = this.$store.state.companyid
        this.mainQuery2.partnerVATID = this.mainledger.partnerVATID
        console.log('Dodajem NOVOG addeditPartner', addeditPartner)
        const newPartner = await PartnerService.post(addeditPartner)
        this.selectPa = {}
        this.selectPa.id = newPartner.data.partner.id ? newPartner.data.partner.id : null
        this.selectPa.partnerName = newPartner.data.partner.partnerName ? newPartner.data.partner.partnerName : null
        this.mainledger.partnerId = newPartner.data.partner.id ? newPartner.data.partner.id : null
        const privateP = this.$store.state.user ? this.$store.state.user.privatePartner : true
        if (privateP) {
          const newPrivatePartner = {}
          newPrivatePartner.CompanyId = newPartner.data.partner.CompanyId
          newPrivatePartner.CompanyNameDatabase = newPartner.data.partner.CompanyNameDatabase
          newPrivatePartner.BusinessYear = newPartner.data.partner.BusinessYear
          newPrivatePartner.UserId = newPartner.data.partner.UserId ? newPartner.data.partner.UserId : ''
          newPrivatePartner.email = newPartner.data.partner.email ? newPartner.data.partner.email : ''
          newPrivatePartner.partnerId = newPartner.data.partner.id ? newPartner.data.partner.id : ''
          newPrivatePartner.partnerNameDatabase = newPartner.data.partner.partnerNameDatabase ? newPartner.data.partner.partnerNameDatabase : ''
          newPrivatePartner.partnerVATID = newPartner.data.partner.partnerVATID ? newPartner.data.partner.partnerVATID : ''
          await PartnerCompanyService.post(newPrivatePartner)
        }
        this.text = this.lang.Partneradded
        this.color = 'green'
        this.snackbar = true
        this.timeout = 2000
        //await checkPartners(1)
        await newUpdates(2)
        await testLastUpdate()
        if (this.$store.state.partnerStore) {
          this.partners = this.$store.state.partnerStore
        }

           
            // this.selectId = this.mainledger.partnerId ? parseInt(this.mainledger.partnerId) : null
            //this.selectPa = this.selectId ? this.partners.find(partner => (partner.partnerVATID === newPartner.data.partner.partnerVATID)) : null
        
            
        this.saving = false
    },
    copyDate() {
      if ((this.mainledger.BookingDate !== this.mainledger.InvoiceDate) && this.$store.state.editItem === 0) {
        this.mainledger.InvoiceDate = this.mainledger.BookingDate ? this.mainledger.BookingDate : dayjs(new Date()).format('YYYY-MM-DD')
        const haveYear = parseInt(this.mainledger.InvoiceDate.toString().substr(0,4))
        const haveMonth = parseInt(this.mainledger.InvoiceDate.toString().substr(5,2)) - 1
        const haveDay = parseInt(this.mainledger.InvoiceDate.toString().substr(8,2))
        this.mainledger.InvoicePaymentDeadlineDate = dayjs(new Date(haveYear, haveMonth, haveDay)).add(15, 'days').format('YYYY-MM-DD')
      }
    },
    // Gotovina i kartica znace da je racun placen na licu mjesta - papirnati slip
    // s benzinske ili iz trgovine. Tada se ne radi virman.
    primijeniNacinPlacanja () {
      const nacin = nacinPoOznaci(this.nacinPlacanjaOznaka)
      this.mainledger.PaymentMeansCode = nacin.sifra
      if (nacin.placeno && !this.mainledger.paidClosed) {
        this.mainledger.paidClosed = true
        if (!this.mainledger.paidDate) {
          this.mainledger.paidDate = this.mainledger.InvoiceDate
            ? dayjs(this.mainledger.InvoiceDate).format('YYYY-MM-DD')
            : new Date().toISOString().substr(0, 10)
        }
      }
    },
    localMoney (iznos) {
      return moneyFormat(iznos)
    },
    imaNeki (vrijednosti) {
      return vrijednosti.some(v => {
        if (v === null || v === undefined || v === '') { return false }
        const broj = parseFloat(v)
        return isNaN(broj) ? String(v).trim().length > 0 : broj !== 0
      })
    },
    imaIznos (vrijednost) {
      return (parseFloat(vrijednost) || 0) !== 0
    },
    paidCheck() {
      if (this.mainledger.paidClosed) {
        if (round(parseFloat(this.mainledger.InvoiceAmount),2) !== 0 && !this.mainledger.paidDate) {
          this.mainledger.paidHome = this.mainledger.InvoiceAmount
          this.mainledger.paidDate = new Date().toISOString().substr(0, 10) 
        }
      }
      if (!this.mainledger.paidClosed) {
          this.mainledger.paidAmount = 0
          this.mainledger.paidFore = 0
          this.mainledger.paidDate = null
      }
    }
  },
  watch: {
    'mainledger.BookingDate' () {
      this.copyDate()
    },
    'mainledger.paidClosed' () {
      this.paidCheck()
    },
    'nacinPlacanjaOznaka' () {
      this.primijeniNacinPlacanja()
    },
    'mainledger.PaymentMeansCode' (novi) {
      const oznaka = nacinIzSifre(novi).oznaka
      if (oznaka !== this.nacinPlacanjaOznaka) { this.nacinPlacanjaOznaka = oznaka }
    },
    'mainledger.VAT1Amount' () {
      this.calculateFirstVAT()
    },
    'mainledger.VAT1PerCanUse' () {
      this.calculateFirstVAT()
    },
    'mainledger.VAT2Amount' () {
      this.calculateSecondVAT()
    },
    'mainledger.VAT2PerCanUse' () {
      this.calculateSecondVAT()
    },
    'mainledger.VAT3Amount' () {
     this.calculateThirdVAT()
    },
    'mainledger.VAT3PerCanUse' () {
      this.calculateThirdVAT()
    },
    'mainledger.InvoiceAmount' () {
      if (this.mainledger.InvoiceAmount && this.mainledger.InvoiceAmount !==0) {
        this.mainledger.InvoiceForeginAmount = this.round((this.mainledger.InvoiceAmount / this.mainledger.ExRate),2)

        this.calculateFirstAmount()
      }
    },
    'mainledger.partnerNotInVAT' () {
      this.showVAT= this.mainledger.partnerNotInVAT ? false : true
    },
    // 'mainledger.InvoiceForeginAmount' () {
    //   this.calculateFirstAmount()
    // },
    'mainledger.VAT4Base' () {
      this.calculateVATAmount()
    },
    'selectPa' () {
      // Dok se racun ucitava partner se ne dira - podaci na racunu su mjerodavni.
      if (this.punjenjeRacuna) { return }
      if (this.selectPa) {
        this.mijenjamPartnera = false
        this.findPartner()
      }
      if (!this.selectPa) {
        this.mainledger.partnerId = null
        this.mainledger.partnerName = null
        this.mainledger.partnerNameShort = null
        this.mainledger.partnerNameDatabase = null
        this.mainledger.partnerBuildingNameNumber = null
        this.mainledger.partnerStreet = null
        this.mainledger.partnerCity = null
        this.mainledger.partnerPostcode = null
        this.mainledger.partnerCountyRegion = null
        this.mainledger.partnerState = null
        this.mainledger.partnerVATID = null
        this.mainledger.partneremail = null
        this.mainledger.partnerPhones = null
        this.mainledger.partnerBankName = null
        this.mainledger.partnerBankAddress = null
        this.mainledger.partnerBankIBAN = null
        this.mainledger.partnerBankSWIFT = null
      }
    },
    'bookTypeSelected' () {
      if (this.bookTypeSelected && this.bookTypeSelected.value) {
        this.mainledger.BookTypeID = parseInt(this.bookTypeSelected.value)
        this.mainledger.BookName = this.bookTypeSelected.text
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Zajednicki stil obrazaca je u src/assets/forma.css (klasa "forma-erp"). */
</style>
